// import { useEffect, useState, useRef } from 'react';
// import axios from 'axios';
// import { toast } from 'react-toastify';
// import { Scroll } from '../../utilities/Shared';
// // FullCalendar + Draggable
// import FullCalendar from '@fullcalendar/react';
// import dayGridPlugin from '@fullcalendar/daygrid';
// import timeGridPlugin from '@fullcalendar/timegrid';
// import interactionPlugin, { Draggable } from '@fullcalendar/interaction';
// import { colorchange } from '../../utilities/Convertions';

// const M110 = () => {
//   const api = 'https://highgroundapi.herokuapp.com';
//   const config = { headers: { 'Content-Type': 'application/json' } };
//   const currentMachine = 'M110';
//   const listItemsRef = useRef([]);

//   const [rawJobs, setRawJobs] = useState([]);
//   const [allScheduled, setAllScheduled] = useState([]);
//   const [machineScheduled, setMachineScheduled] = useState([]);
//   const [displayList, setDisplayList] = useState([]);
//   const [sortOption, setSortOption] = useState('job');
//   const [selectedEvent, setSelectedEvent] = useState(null);
//   const [refreshTrigger, setRefreshTrigger] = useState(0);
//   const [scheduleEditFormData, setScheduleEditFormData] = useState({});
//   const [isScheduleEditModalOpen, setIsScheduleEditModalOpen] = useState(false);
//   const [isCreateNoteModalOpen, setIsCreateNoteModalOpen] = useState(false);
//   const [createNoteForm, setCreateNoteForm] = useState({
//     startDate: new Date().toISOString().slice(0, 16),
//     durationHours: 0.5,
//     content: '',
//   });
//   const [jobPressTimeMap, setJobPressTimeMap] = useState({});

//   const channel = new BroadcastChannel('schedule-update');

//   // Helper to determine presstype based on press value
//   const getPressType = (press) => {
//     const p = String(press);
//     if (p === '5') return 'Folding';
//     if (p === '6') return 'Sheeter';
//     return ''; // default / unknown
//   };

//   // ── 1. Save / Edit ───────────────────────────────────────────────────────
//   const handleScheduleEditSubmit = async (e) => {
//     e.preventDefault();
//     if (!selectedEvent) return;
//     try {
//       if (selectedEvent.extendedProps.isNote) {
//         const content = scheduleEditFormData.content || '';
//         const dbId = selectedEvent.extendedProps.dbId;
//         const startStr = selectedEvent.start ? selectedEvent.start.toISOString() : null;
//         const endStr = selectedEvent.end ? selectedEvent.end.toISOString() : null;
//         let res;
//         if (dbId) {
//           res = await axios.post(`${api}/sched/updatecal`, {
//             _id: dbId,
//             start: startStr,
//             end: endStr,
//             content,
//             isNote: true,
//             machine: currentMachine
//           });
//         } else {
//           res = await axios.post(`${api}/sched/add`, {
//             start: startStr,
//             end: endStr,
//             content,
//             isNote: true,
//             machine: currentMachine
//           });
//           if (res.data?.schedule?._id || res.data?._id) {
//             const newId = res.data.schedule?._id || res.data._id;
//             selectedEvent.setProp('id', `db-${newId}`);
//             selectedEvent.setExtendedProp('dbId', newId);
//           } else {
//             throw new Error("No _id returned from create");
//           }
//         }
//         selectedEvent.setProp('title', content.trim() || 'Note');
//         selectedEvent.setExtendedProp('content', content);
//         setMachineScheduled(prev =>
//           prev.map(e =>
//             e.id === selectedEvent.id
//               ? { ...e, start: startStr, end: endStr, title: content.trim() || 'Note', extendedProps: { ...e.extendedProps, content } }
//               : e
//           )
//         );
//         toast.success(dbId ? "Note updated" : "Note created");
//         setIsScheduleEditModalOpen(false);
//         return;
//       }
//       // Normal job handling
//       const hrs = parseFloat(scheduleEditFormData.hours) || 0;
//       // Use edited start time (or fallback to original)
//       const newStart = scheduleEditFormData.start
//         ? new Date(scheduleEditFormData.start)
//         : selectedEvent.start;
//       if (isNaN(newStart.getTime())) {
//         toast.error("Invalid start date/time");
//         return;
//       }
//       const newEnd = new Date(newStart);
//       newEnd.setMinutes(newEnd.getMinutes() + hrs * 60);
//       const payload = {
//         _id: selectedEvent.extendedProps.dbId,
//         job: scheduleEditFormData.job,
//         component: scheduleEditFormData.component,
//         fink: scheduleEditFormData.fink,
//         bink: scheduleEditFormData.bink,
//         sheetl: scheduleEditFormData.sheetl,
//         sheetw: scheduleEditFormData.sheetw,
//         faq: scheduleEditFormData.faq,
//         baq: scheduleEditFormData.baq,
//         method: scheduleEditFormData.method,
//         hours: hrs,
//         customer: scheduleEditFormData.customer,
//         status: scheduleEditFormData.status,
//         start: newStart.toISOString(),
//         end: newEnd.toISOString(),
//         machine: scheduleEditFormData.machine || currentMachine,
//         presstype: scheduleEditFormData.presstype || getPressType(scheduleEditFormData.press || selectedEvent.extendedProps.press || '')
//       };
//       await axios.post(`${api}/sched/updatecal`, payload);
//       // Update FullCalendar event
//       selectedEvent.setStart(newStart);
//       selectedEvent.setEnd(newEnd);
//       // Update extended props (skip 'start' since we already set it via setStart)
//       Object.entries(scheduleEditFormData).forEach(([key, val]) => {
//         if (key !== 'start') {
//           selectedEvent.setExtendedProp(key, val);
//         }
//       });
//       selectedEvent.setProp(
//         "title",
//         `${scheduleEditFormData.job || "N/A"}${scheduleEditFormData.component ? ` - ${scheduleEditFormData.component}` : ""}`
//       );
//       // Update local machineScheduled state
//       setMachineScheduled(prev =>
//         prev.map(e =>
//           e.id === selectedEvent.id
//             ? {
//                 ...e,
//                 start: newStart.toISOString(),
//                 end: newEnd.toISOString(),
//                 extendedProps: {
//                   ...e.extendedProps,
//                   ...scheduleEditFormData,
//                   start: newStart.toISOString()
//                 }
//               }
//             : e
//         )
//       );
//       setIsScheduleEditModalOpen(false);
//       toast.success("Schedule updated");
//       window.location.reload(); // or use setRefreshTrigger(prev => prev + 1) instead
//     } catch (err) {
//       console.error(err);
//       toast.error("Update failed");
//     }
//   };

//   // ── 2. Duplicate ─────────────────────────────────────────────────────────
//   const handleScheduleDuplicate = async () => {
//     if (!selectedEvent) return;
//     try {
//       if (!selectedEvent.start || isNaN(selectedEvent.start.getTime())) {
//         toast.error("Cannot duplicate: original event has invalid start time");
//         return;
//       }
//       const originalStart = new Date(selectedEvent.start);
//       const originalEnd = selectedEvent.end && !isNaN(selectedEvent.end.getTime())
//         ? new Date(selectedEvent.end)
//         : new Date(originalStart.getTime() + 60 * 60 * 1000);
//       const duration = originalEnd - originalStart;
//       if (duration <= 0) {
//         toast.error("Cannot duplicate: event duration is zero or negative");
//         return;
//       }
//       const newStart = new Date(originalStart);
//       const newEnd = new Date(newStart.getTime() + duration);
//       const payload = {
//         ...selectedEvent.extendedProps,
//         start: newStart,
//         end: newEnd,
//         machine: currentMachine
//       };
//       delete payload.dbId;
//       delete payload._id;
//       const res = await axios.post(`${api}/sched/add`, payload);
//       const newDbId = res.data._id;
//       if (!newDbId) throw new Error("Failed to get _id from server");
//       const newEvent = {
//         id: `db-${newDbId}`,
//         title: selectedEvent.title,
//         start: newStart.toISOString(),
//         end: newEnd.toISOString(),
//         extendedProps: {
//           ...payload,
//           dbId: newDbId
//         },
//         backgroundColor: selectedEvent.backgroundColor,
//         borderColor: '#000',
//         textColor: '#000'
//       };
//       setMachineScheduled(prev => [...prev, newEvent]);
//       setIsScheduleEditModalOpen(false);
//       toast.success("Duplicated successfully");
//     } catch (err) {
//       console.error("Duplicate failed:", err);
//       toast.error("Duplicate failed");
//     }
//   };

//   // ── 3. Delete ────────────────────────────────────────────────────────────
//   const handleScheduleRemove = async () => {
//     if (!selectedEvent) return;
//     try {
//       const dbId = selectedEvent.extendedProps.dbId;
//       if (!dbId) {
//         selectedEvent.remove();
//         setMachineScheduled(prev => prev.filter(e => e.id !== selectedEvent.id));
//         toast.success("Note removed (was never saved)");
//         setIsScheduleEditModalOpen(false);
//         setRefreshTrigger(prev => prev + 1);
//         channel.postMessage('refresh');
//         return;
//       }
//       await axios.post(`${api}/sched/remove`, { id: dbId });
//       selectedEvent.remove();
//       setMachineScheduled(prev => prev.filter(e => e.extendedProps.dbId !== dbId));
//       setIsScheduleEditModalOpen(false);
//       toast.success(selectedEvent.extendedProps.isNote ? "Note deleted" : "Schedule deleted");
//       setRefreshTrigger(prev => prev + 1);
//       window.location.reload();
//       channel.postMessage('refresh');
//     } catch (err) {
//       console.error("Delete failed:", err);
//       toast.error("Delete failed");
//     }
//   };

//   // ── Double-click to edit ─────────────────────────────────────────────────
//   const handleEventDoubleClick = (info) => {
//     const ev = info.event;
//     setSelectedEvent(ev);
//     if (ev.extendedProps.isNote) {
//       setScheduleEditFormData({
//         content: ev.extendedProps.content || '',
//         start: ev.start,
//         end: ev.end
//       });
//     } else {
//       setScheduleEditFormData({
//         job: ev.extendedProps.job || '',
//         component: ev.extendedProps.component || '',
//         fink: ev.extendedProps.fink || '',
//         bink: ev.extendedProps.bink || '',
//         faq: ev.extendedProps.faq || '',
//         baq: ev.extendedProps.baq || '',
//         sheetl: ev.extendedProps.sheetl || '',
//         sheetw: ev.extendedProps.sheetw || '',
//         method: ev.extendedProps.method || '',
//         hours: ev.extendedProps.hours || ((ev.end - ev.start) / (1000 * 60 * 60)).toFixed(2),
//         customer: ev.extendedProps.customer || '',
//         status: ev.extendedProps.status || ev.extendedProps.currentstatus || 'On Incoming',
//         machine: ev.extendedProps.machine || currentMachine,
//         start: ev.start
//           ? `${ev.start.getFullYear()}-${String(ev.start.getMonth() + 1).padStart(2, '0')}-${String(ev.start.getDate()).padStart(2, '0')}T${String(ev.start.getHours()).padStart(2, '0')}:${String(ev.start.getMinutes()).padStart(2, '0')}`
//           : ''
//       });
//     }
//     setIsScheduleEditModalOpen(true);
//   };

//   // ── Fetch open jobs ──────────────────────────────────────────────────────
//   useEffect(() => {
//     const fetchActiveJobs = async () => {
//       try {
//         const res = await axios.post('https://highgroundapi.herokuapp.com/jobs/openjobs');
//         setRawJobs(Array.isArray(res.data) ? res.data : []);
//       } catch (err) {
//         toast.error('Failed to load open jobs');
//         setRawJobs([]);
//       }
//     };
//     fetchActiveJobs();
//   }, []);

//   const fetchScheduled = async () => {
//     try {
//       const res = await axios.post(`${api}/sched/sheetfed`, { machine: ['M110'] });
//       const data = Array.isArray(res.data) ? res.data : [];
//       setAllScheduled(data.map(item => ({
//         job: String(item.job || '').trim(),
//         component: String(item.component || '').trim(),
//       })));
//       let machineEvents = data
//         .filter(item => String(item.machine || '').trim() === currentMachine)
//         .map(item => {
//           if (item.isNote) {
//             const start = new Date(item.start);
//             const end = item.end ? new Date(item.end) : new Date(start.getTime() + 60*60*1000);
//             return {
//               id: `db-${item._id}`,
//               title: 'Note',
//               start: start.toISOString(),
//               end: end.toISOString(),
//               extendedProps: {
//                 isNote: true,
//                 content: item.content || '',
//                 hours: 1,
//                 dbId: item._id,
//                 customer: item.customer || 'N/A',
//                 status: 'Note',
//               },
//               backgroundColor: '#fffa65',
//               borderColor: '#fffa65',
//               textColor: '#000'
//             };
//           }
//           const start = item.start ? new Date(item.start) : null;
//           const end = item.end ? new Date(item.end) : null;
//           const eventId = item._id ? `db-${item._id}` : `${item.job}-${item.component || 'no-comp'}-${start?.getTime() || 'no-start'}`;
//           return {
//             id: eventId,
//             title: `${item.job || 'N/A'}${item.component ? ` - ${item.component}` : ''}`,
//             start: start?.toISOString() ?? null,
//             end: end?.toISOString() ?? null,
//             extendedProps: {
//               job: item.job,
//               component: item.component,
//               customer: item.customer || 'N/A',
//               status: item.status || 'Scheduled',
//               currentstatus: item.currentstatus || item.status || 'Scheduled',
//               fink: item.fink || '',
//               bink: item.bink || '',
//               faq: item.faq || '',
//               baq: item.baq || '',
//               sheetl: item.sheetl || '',
//               sheetw: item.sheetw || '',
//               method: item.method || '',
//               dbId: item._id
//             },
//             backgroundColor: colorchange(item.status || 'Scheduled'),
//             borderColor: '#000',
//             textColor: '#000'
//           };
//         })
//         .filter(e => e.start);
//       if (machineEvents.length > 0) {
//         const payload = {
//           items: machineEvents.map(e => ({
//             job: e.extendedProps.job || '',
//             component: e.extendedProps.component || null
//           })).filter(i => i.job)
//         };
//         if (payload.items.length > 0) {
//           try {
//             const resStatus = await axios.post(`https://highgroundsoftware.com/dash/dashboard/php/getnewoperations.php`, payload, config);
//             if (resStatus.data.success) {
//               const statusMap = {};
//               resStatus.data.results?.forEach(r => {
//                 statusMap[`${r.job}|${r.component || 'NULL'}`] = r.name || 'Scheduled';
//               });
//               machineEvents = machineEvents.map(e => {
//                 const key = `${e.extendedProps.job}|${e.extendedProps.component || 'NULL'}`;
//                 if (statusMap[key]) {
//                   const newStatus = statusMap[key];
//                   return {
//                     ...e,
//                     extendedProps: { ...e.extendedProps, status: newStatus, currentstatus: newStatus },
//                     backgroundColor: colorchange(newStatus)
//                   };
//                 }
//                 return e;
//               });
//             }
//           } catch (err) {
//             // silent fail
//           }
//         }
//       }
//       setMachineScheduled(machineEvents);
//     } catch (err) {
//       toast.error('Failed to load scheduled jobs');
//       setAllScheduled([]);
//       setMachineScheduled([]);
//     }
//   };

//   useEffect(() => {
//     fetchScheduled();
//   }, []);

//   // ── Expand + filter + sort + real status + PRESS TIME + per-form split ───
//   useEffect(() => {
//     const expanded = [];
//     rawJobs.forEach(job => {
//       const impositions = job.imposition || [];
//       impositions.forEach(impo => {
//         const pressNum = Number(impo.press) || 0;
//         if (pressNum !== 5 && pressNum !== 6) return;
//         const numForms = Number(impo.numforms) || 1;
//         for (let i = 1; i <= numForms; i++) {
//           let displayComponent = impo.component || 'N/A';
//           if (numForms > 1) displayComponent = `${i}) ${displayComponent}`;
//           expanded.push({
//             ...job,
//             ...impo,
//             formIndex: i,
//             _displayPrefix: numForms > 1 ? `${i}) ` : '',
//             displayComponent,
//             originalComponent: impo.component || 'N/A',
//             status: impo.status || job.status || 'On Incoming',
//             currentstatus: impo.currentstatus || job.currentstatus || 'On Incoming',
//             presstime1: impo.presstime1 || '1',
//             numforms: numForms
//           });
//         }
//       });
//     });
//     let sorted = [...expanded];
//     if (sortOption === 'dueDate') {
//       sorted.sort((a, b) => new Date(a.duedate || '9999') - new Date(b.duedate || '9999'));
//     } else if (sortOption === 'customer') {
//       sorted.sort((a, b) => (a.customer || '').localeCompare(b.customer || ''));
//     } else {
//       sorted.sort((a, b) => (a.job || '').localeCompare(b.job || ''));
//     }
//     const filtered = sorted.filter(item => {
//       const jobStr = String(item.job || '').trim();
//       const compStr = String(item.originalComponent || item.component || '').trim();
//       return !allScheduled.some(s =>
//         String(s.job).trim() === jobStr && String(s.component).trim() === compStr
//       );
//     });
//     const applyRealStatusAndTimes = async () => {
//       let updated = [...filtered];
//       // Real status fetch (unchanged)
//       const statusPayload = {
//         items: filtered.map(item => ({
//           job: String(item.job || '').trim(),
//           component: String(item.displayComponent || item.component || '').trim() || null
//         })).filter(i => i.job)
//       };
//       if (statusPayload.items.length > 0) {
//         try {
//           const res = await axios.post(`https://highgroundsoftware.com/dash/dashboard/php/getnewoperations.php`, statusPayload, config);
//           if (res.data.success) {
//             const statusMap = {};
//             res.data.results?.forEach(r => {
//               statusMap[`${r.job}|${r.component || 'NULL'}`] = r.name || 'On Incoming';
//             });
//             updated.forEach(item => {
//               const key = `${String(item.job || '').trim()}|${String(item.displayComponent || item.component || '').trim() || 'NULL'}`;
//               if (statusMap[key]) {
//                 item.currentstatus = statusMap[key];
//                 item.status = statusMap[key];
//               }
//             });
//           }
//         } catch (err) {
//           // silent fail
//         }
//       }
//       // Press time fetch - build per-component map + total fallback
//       const uniqueQuotes = [...new Set(updated.map(item => String(item.quote || '').trim()).filter(Boolean))];
//       let fetchedTimeMap = {}; // quote → total (fallback)
//       let componentTimeMap = {}; // quote → { "COVER": 6, "FORM 04PG": 4.5, ... }
//       if (uniqueQuotes.length > 0) {
//         try {
//           const timeRes = await axios.post(
//             `https://highgroundsoftware.com/dash/dashboard/php/getpresstimes.php`,
//             { jobs: uniqueQuotes },
//             config
//           );
       
//           if (Array.isArray(timeRes.data)) {
//             timeRes.data.forEach(row => {
//               const quoteKey = String(row.quote || row.Quote || '').trim();
//               if (!quoteKey) return;
//               const compKey = String(row.component || '').trim().toUpperCase();
//               const t1 = parseFloat(row.presstime1) || 0;
//               const t2 = parseFloat(row.presstime2) || 0;
//               const totalForRow = t1 + t2;
//               // Store per-component (prefer t1 as main press time)
//               if (compKey) {
//                 if (!componentTimeMap[quoteKey]) componentTimeMap[quoteKey] = {};
//                 componentTimeMap[quoteKey][compKey] = t1 || totalForRow;
               
//               }
//               // Accumulate total for fallback
//               if (!fetchedTimeMap[quoteKey]) fetchedTimeMap[quoteKey] = 0;
//               fetchedTimeMap[quoteKey] += totalForRow;
//             });
//           }
//         } catch (err) {
//           console.warn("Failed to load press times per job", err);
//         }
//       }
//       setJobPressTimeMap(fetchedTimeMap);
//       // Assign time: match by component first, then split evenly if numforms > 1
//       updated = updated.map(item => {
//         const quoteKey = String(item.quote || '').trim();
//         const compName = String(item.component || item.originalComponent || '').trim().toUpperCase();
//         const numForms = Number(item.numforms) || 1;
//         let hoursThisForm = 1.5; // default fallback
//         // 1. Get the base time for this component
//         let baseTime = 1.5;
//         if (componentTimeMap[quoteKey] && componentTimeMap[quoteKey][compName] > 0) {
//           baseTime = componentTimeMap[quoteKey][compName];
         
//         }
//         else if (fetchedTimeMap[quoteKey] > 0) {
//           const impositionCount = updated.filter(i => String(i.quote || '').trim() === quoteKey).length || 1;
//           baseTime = fetchedTimeMap[quoteKey] / impositionCount;
         
//         }
//         else {
         
//         }
//         // 2. Split evenly if numforms > 1
//         if (numForms > 1) {
//           hoursThisForm = baseTime / numForms;
//           console.log(`Split ${baseTime.toFixed(2)} hr across ${numForms} forms → ${hoursThisForm.toFixed(2)} hr per form`);
//         } else {
//           hoursThisForm = baseTime;
//         }
//         return { ...item, pressTimePerForm: hoursThisForm };
//       });
//       const finalList = updated.filter(openItem => {
//         const openJob = String(openItem.job || '').trim();
//         const openComp = String(openItem.displayComponent || openItem.component || '').trim();
//         return !machineScheduled.some(sched => {
//           const schedJob = String(sched.extendedProps.job || '').trim();
//           const schedComp = String(sched.extendedProps.component || '').trim();
//           return schedJob === openJob && schedComp === openComp;
//         }) &&
//         !allScheduled.some(s => {
//           const sJob = String(s.job || '').trim();
//           const sComp = String(s.component || '').trim();
//           return sJob === openJob && sComp === openComp;
//         });
//       });
//       setDisplayList(finalList);
//     };
//     applyRealStatusAndTimes();
//   }, [rawJobs, allScheduled, sortOption, machineScheduled, refreshTrigger]);

//   useEffect(() => {
//     channel.onmessage = (event) => {
//       if (event.data === 'refresh') {
//         fetchScheduled();
//       }
//     };
//     return () => {
//       channel.close();
//     };
//   }, []);

//   console.log(displayList)

//   // ── Make open items draggable ────────────────────────────────────────────
//   useEffect(() => {
//     const draggables = [];
//     listItemsRef.current.forEach((el, idx) => {
//       if (!el || !displayList[idx]) return;
//       const item = displayList[idx];
//       const hours = parseFloat(item.pressTimePerForm) || 1.5;

//       const draggable = new Draggable(el, {
//         eventData: {
//           title: `${item.job || 'N/A'}${item.displayComponent ? ` - ${item.displayComponent}` : ''}`,
//           duration: `${Math.floor(hours)}:${Math.round((hours % 1) * 60).toString().padStart(2, '0')}:00`,
//           extendedProps: {
//             customer: item.customer || 'N/A',
//             status: item.status || 'On Incoming',
//             currentstatus: item.currentstatus || 'On Incoming',
//             hours: hours.toString(),
//             component: item.displayComponent || item.component || null,
//             job: item.job || '',
//             fink: item.fink || '',
//             bink: item.bink || '',
//             faq: item.faq || '',
//             baq: item.baq || '',
//             sheetl: item.sheetl || '',
//             sheetw: item.sheetw || '',
//             method: item.method || '',
//             _id: null,
//             press: item.press || '',
//             presstype: getPressType(item.press)  // ← added here
//           }
//         }
//       });
//       draggables.push(draggable);
//     });
//     return () => draggables.forEach(d => d.destroy());
//   }, [displayList]);

//   // ── Handle event drop ────────────────────────────────────────────────────
//   const handleEventDrop = async (info) => {
//     const event = info.event;
//     if (!event.start || isNaN(event.start.getTime())) {
//       console.warn("Invalid drop - start is null or invalid", event);
//       info.revert();
//       toast.error("Cannot drop here (outside allowed time range)");
//       return;
//     }
//     const safeEnd = event.end && !isNaN(event.end.getTime())
//       ? event.end
//       : new Date(event.start.getTime() + 60 * 60 * 1000);
//     const dbId = event.extendedProps.dbId;
//     const isNote = !!event.extendedProps.isNote;
//     const payload = {
//       _id: dbId,
//       machine: currentMachine,
//       start: event.start.toISOString(),
//       end: safeEnd.toISOString(),
//       isNote: isNote,
//     };
//     if (!isNote) {
//       payload.job = event.extendedProps.job || event.title.split(' - ')[0] || '';
//       payload.component = event.extendedProps.component || '';
//       payload.customer = event.extendedProps.customer || '';
//       payload.status = event.extendedProps.status || event.extendedProps.currentstatus || 'On Incoming';
//       payload.hours = ((safeEnd - event.start) / (1000 * 60 * 60)).toFixed(2);
//       payload.fink = event.extendedProps.fink || '';
//       payload.bink = event.extendedProps.bink || '';
//       payload.faq = event.extendedProps.faq || '';
//       payload.baq = event.extendedProps.baq || '';
//       payload.sheetl = event.extendedProps.sheetl || '';
//       payload.sheetw = event.extendedProps.sheetw || '';
//       payload.method = event.extendedProps.method || '';
//       payload.presstype = event.extendedProps.presstype || '';  // ← added here
//     } else {
//       payload.content = event.extendedProps.content || '';
//     }
//     try {
//       const res = await axios.post(`${api}/sched/updatecal`, payload);
//       if (res.data.success || res.data._id) {
//         toast.success('Event moved and saved');
//         setMachineScheduled(prev =>
//           prev.map(e =>
//             e.id === event.id
//               ? { ...e, start: event.start, end: safeEnd }
//               : e
//           )
//         );
//       } else {
//         throw new Error('Save failed');
//       }
//     } catch (err) {
//       console.error(err);
//       toast.error('Failed to save moved event');
//       info.revert();
//     }
//   };

//   // ── Handle modal save (unused) ───────────────────────────────────────────
//   const handleModalSave = async () => {
//     const event = selectedEvent;
//     let dbId;
//     if (event.id.startsWith('db-')) {
//       dbId = event.id.replace('db-', '');
//     }
//     const payload = {
//       _id: dbId,
//       machine: currentMachine,
//       job: event.extendedProps.job,
//       component: event.extendedProps.component,
//       start: event.start.toISOString(),
//       end: event.end.toISOString(),
//       customer: event.extendedProps.customer,
//       status: event.extendedProps.status
//     };
//     try {
//       await axios.post(`${api}/sched/updatecal`, payload);
//       setMachineScheduled(prev =>
//         prev.map(e =>
//           e.id === event.id
//             ? { ...e, extendedProps: event.extendedProps }
//             : e
//         )
//       );
//       toast.success('Updated');
//       setIsScheduleEditModalOpen(false);
//     } catch (err) {
//       toast.error('Update failed');
//     }
//   };

//   // ── Handle drop from left to calendar ────────────────────────────────────
//   const handleEventReceive = async (info) => {
//     console.log('handleEventReceive triggered');
//     const draggedEl = info.draggedEl;
//     if (!draggedEl) {
//       console.log('No draggedEl');
//       toast.error('Drag failed - try again');
//       info.revert();
//       return;
//     }
//     let itemIndex = -1;
//     if (draggedEl.parentNode) {
//       itemIndex = Array.from(draggedEl.parentNode.children).indexOf(draggedEl);
//     }
//     if (itemIndex === -1) {
//       const job = draggedEl.dataset.job;
//       const component = draggedEl.dataset.component;
//       console.log('Fallback lookup - job:', job, 'component:', component);
//       if (job) {
//         itemIndex = displayList.findIndex(item =>
//           item.job === job &&
//           (item.originalComponent || item.component) === component
//         );
//       }
//     }
//     console.log('Found itemIndex:', itemIndex);
//     const item = itemIndex >= 0 ? displayList[itemIndex] : null;
//     if (!item) {
//       console.log('No item found in displayList');
//       toast.error('Item not found');
//       info.revert();
//       return;
//     }
//     console.log('Dragged item data:', {
//       job: item.job,
//       component: item.component,
//       originalComponent: item.originalComponent,
//       displayComponent: item.displayComponent,
//       numforms: item.numforms
//     });
//     const start = info.event.start;
//     const hours = parseFloat(item.pressTimePerForm) || 1;
//     const end = new Date(start);
//     end.setHours(end.getHours() + hours);
//     // Choose component to save
//     let savedComponent;
//     const numForms = Number(item.numforms) || 1;
//     if (numForms > 1) {
//       savedComponent = item.displayComponent || item.component || 'N/A';
//       console.log('Multi-form → using prefixed:', savedComponent);
//     } else {
//       savedComponent = item.originalComponent || item.component || 'N/A';
//       console.log('Single-form → using clean:', savedComponent);
//     }
//     const newEvent = {
//       id: `${item.job}-${savedComponent}-${start.toISOString()}`,
//       title: `${item.job || 'N/A'} - ${savedComponent}`,
//       start: start.toISOString(),
//       end: end.toISOString(),
//       extendedProps: {
//         customer: item.customer || 'N/A',
//         status: item.status || 'On Incoming',
//         currentstatus: item.currentstatus || 'On Incoming',
//         hours: hours.toString(),
//         component: savedComponent,
//         originalComponent: item.originalComponent || item.component || null,
//         job: item.job,
//         fink: item.fink || '',
//         bink: item.bink || '',
//         faq: item.faq || '',
//         baq: item.baq || '',
//         sheetl: item.sheetl || '',
//         sheetw: item.sheetw || '',
//         method: item.method || '',
//         presstype: getPressType(item.press)  // ← added here
//       },
//       backgroundColor: colorchange(item.status || 'On Incoming'),
//       borderColor: '#000',
//       textColor: '#000'
//     };
//     try {
//       const payload = {
//         machine: currentMachine,
//         job: newEvent.extendedProps.job,
//         component: newEvent.extendedProps.component,
//         start: newEvent.start,
//         end: newEvent.end,
//         customer: newEvent.extendedProps.customer,
//         status: newEvent.extendedProps.status,
//         hours: newEvent.extendedProps.hours,
//         fink: newEvent.extendedProps.fink,
//         bink: newEvent.extendedProps.bink,
//         faq: newEvent.extendedProps.faq,
//         baq: newEvent.extendedProps.baq,
//         sheetl: newEvent.extendedProps.sheetl,
//         sheetw: newEvent.extendedProps.sheetw,
//         method: newEvent.extendedProps.method,
//         presstype: newEvent.extendedProps.presstype  // ← added here
//       };
//       console.log('Sending payload to /sched/add:', payload);
//       const res = await axios.post(`${api}/sched/add`, payload, config);
//       console.log('Server response:', res.data);
//       if (res.data._id || res.data.success) {
//         newEvent.id = `db-${res.data._id}`;
//         newEvent.extendedProps.dbId = res.data._id;
//         setMachineScheduled(prev => [...prev, newEvent]);
//         setDisplayList(prev => prev.filter((_, idx) => idx !== itemIndex));
//         toast.success('Event added to schedule');
//       } else {
//         console.log('Save failed - no _id or success in response');
//         throw new Error('Save failed - no ID or success returned');
//       }
//     } catch (err) {
//       console.error('Save error details:', err.response?.data || err.message);
//       toast.error('Failed to save event');
//       info.revert();
//     }
//   };

//   const handleStatusChange = async (newStatus) => {
//     if (!selectedEvent) return;
//     const oldStatus = scheduleEditFormData.status || 'On Incoming';
//     // Optimistic preview in UI & calendar
//     setScheduleEditFormData(prev => ({
//       ...prev,
//       status: newStatus,
//       currentstatus: newStatus,
//     }));
//     if (!selectedEvent.extendedProps.isNote) {
//       selectedEvent.setExtendedProp('status', newStatus);
//       selectedEvent.setExtendedProp('currentstatus', newStatus);
//       selectedEvent.setProp('backgroundColor', colorchange(newStatus));
//       selectedEvent.setProp('textColor', 'black');
//     }
//     // Prepare payload similar to your full save, but focused/minimal
//     const payload = {
//       // Required / important fields your PHP binds
//       job: parseInt(selectedEvent.extendedProps.job) || parseInt(scheduleEditFormData.job) || '',
//       comp: selectedEvent.extendedProps.component || scheduleEditFormData.component || '',
//       process: parseInt(selectedEvent.extendedProps.process) || 3,
//       status: newStatus,
//       changedby: 1,
//       name: selectedEvent.extendedProps.name || newStatus,
//       item: parseInt(selectedEvent.extendedProps.item) || 0,
//       partof: parseInt(selectedEvent.extendedProps.partof) || 0,
//       partofid: parseInt(selectedEvent.extendedProps.partofid) || null,
//       dept: parseInt(selectedEvent.extendedProps.dept) || 3,
//       pages: parseInt(selectedEvent.extendedProps.pages) || 0,
//       up: parseInt(selectedEvent.extendedProps.up) || 0,
//       forms: parseInt(selectedEvent.extendedProps.forms) || 0,
//       press: parseInt(selectedEvent.extendedProps.press) || 0,
//       sheetl: parseInt(selectedEvent.extendedProps.sheetl) || 0,
//       sheetw: parseInt(selectedEvent.extendedProps.sheetw) || 0,
//       method: selectedEvent.extendedProps.method || '',
//       versions: parseInt(selectedEvent.extendedProps.versions) ||1,
//       mr: parseInt(selectedEvent.extendedProps.mr) || 0,
//       cuts: parseInt(selectedEvent.extendedProps.cuts) || 0,
//       foldtype: parseInt(selectedEvent.extendedProps.foldtype) || 0,
//       topress: parseInt(selectedEvent.extendedProps.topress) || 0,
//       push: parseInt(selectedEvent.extendedProps.push) || 0,
//     };
//     try {
//       console.log(payload)
//       const res = await axios.post(`https://highgroundsoftware.com/dash/dashboard/php/addoperation.php`, payload, config);
//       console.log(res.data)
//       if (res.data?.success || res.data?._id) {
//         toast.success(`Status changed to ${newStatus} (new entry created)`);
//         // fetchScheduled();
//         channel.postMessage('refresh');
//       } else {
//         throw new Error("No success or new ID returned");
//       }
//     } catch (err) {
//       console.error("Status add failed:", err);
//       toast.error("Failed to record new status");
//       // Rollback UI preview
//       setScheduleEditFormData(prev => ({
//         ...prev,
//         status: oldStatus,
//         currentstatus: oldStatus,
//       }));
//       if (!selectedEvent.extendedProps.isNote) {
//         selectedEvent.setExtendedProp('status', oldStatus);
//         selectedEvent.setExtendedProp('currentstatus', oldStatus);
//         selectedEvent.setProp('backgroundColor', colorchange(oldStatus));
//       }
//     }
//   };

//   // ── JSX ──────────────────────────────────────────────────────────────────
//   return (
//     <div className="flex h-screen bg-gray-50">
//       {/* Left sidebar - Open Jobs */}
//       <div className="w-1/4 border-r border-gray-300 p-4 flex flex-col">
//         <div className="flex items-center justify-between mb-4">
//           <h3 className="text-lg font-semibold">Open Jobs</h3>
//           <span className="text-sm text-gray-600">{displayList.length} items</span>
//         </div>
//         <div className="mb-3 flex items-center gap-2">
//           <label className="text-sm font-medium">Sort by:</label>
//           <select
//             value={sortOption}
//             onChange={e => setSortOption(e.target.value)}
//             className="border rounded px-2 py-1 text-sm"
//           >
//             <option value="job">Job #</option>
//             <option value="dueDate">Due Date</option>
//             <option value="customer">Customer</option>
//           </select>
//         </div>
//         <Scroll className="flex-1">
//           {displayList.length > 0 ? (
//             displayList.map((item, idx) => (
//               <div
//                 key={`${item.job}-${item.originalComponent}-${item.formIndex}-${idx}`}
//                 ref={el => (listItemsRef.current[idx] = el)}
//                 className="draggable-item p-3 mb-2 bg-white border border-gray-200 rounded shadow-sm hover:shadow-md cursor-move transition"
//                 style={{ backgroundColor: colorchange(item.currentstatus || item.status || 'On Incoming') }}
//                 data-job={item.job}
//                 data-component={item.originalComponent || item.component || ''}
//               >
//                 <div className="font-bold text-base">
//                   {item._displayPrefix}{item.customer || 'Unknown Customer'}
//                 </div>
//                 <div className="mt-1">
//                   Job: <strong>{item.job || 'N/A'}</strong>
//                   {' - '}
//                   <span className={item.numforms > 1 ? 'text-blue-700 font-medium' : ''}>
//                     {item.displayComponent || item.component || 'N/A'}
//                   </span>
//                   {item.numforms > 1 && (
//                     <span className="text-sm text-gray-500 ml-1">(of {item.numforms})</span>
//                   )}
//                 </div>
//                 <div className="mt-1">
//                   Status: <strong>{item.currentstatus || item.status || 'On Incoming'}</strong>
//                 </div>
//                 <div className="text-sm text-gray-600 mt-1">
//                   Due: {item.duedate ? new Date(item.duedate).toLocaleDateString() : '—'}
//                   {' • Press: '}
//                 </div>
//                 <div className="mt-1">
//                   Press time: <strong>{item.pressTimePerForm?.toFixed(2) ?? '—'}</strong> hr
//                   {item.numforms > 1 && <span className="text-gray-500 ml-1">(per form)</span>}
//                 </div>
//                 <div className="mt-1">
//                   Sheet: {item.sheetl || '?'} × {item.sheetw || '?'}
//                   <br />
//                   Inks: {item.fink || '—'} {item.bink ? `/ ${item.bink}` : ''}
//                   <br />
//                   <span
//                     style={{
//                       background: item.faq || item.baq ? "teal" : "inherit",
//                       padding: '0px 40px 0px 0px',
//                       color: item.faq || item.baq ? "white" : "inherit"
//                     }}
//                   >
//                     Coating: {item.faq || '—'} {item.baq ? `/ ${item.baq}` : ''}
//                   </span>
//                   <br />
//                   <span>Method: {item.method || '—'} - {item.press === "5" ? "Folding" : ""}{item.press === "6" ? "Sheeter" : ""}</span>
//                 </div>
//               </div>
//             ))
//           ) : (
//             <div className="p-8 text-center text-gray-500">
//               {rawJobs.length === 0 ? 'Loading open jobs...' : 'No open jobs available'}
//             </div>
//           )}
//         </Scroll>
//       </div>

//       {/* Right side - Calendar */}
//       <div className="flex-1 p-6 flex flex-col">
//         <h2 className="text-2xl font-bold mb-4">{currentMachine} Schedule</h2>

//         <button
//           style={{ background: '#2969ae', color: 'white', padding: '8px 20px', border: 'none', borderRadius: '4px', width: '15%' }}
//           onClick={() => {
//             const today = new Date();
//             const defaultStart = new Date(
//               today.getFullYear(),
//               today.getMonth(),
//               today.getDate(),
//               7,
//               0,
//               0
//             );
//             const formatted = defaultStart.toISOString().slice(0, 16);
//             setCreateNoteForm({
//               startDate: formatted,
//               durationHours: 1,
//               content: '',
//             });
//             setIsCreateNoteModalOpen(true);
//           }}
//         >
//           Add Note
//         </button>

//         <div className="flex-1 bg-white border rounded overflow-hidden mt-4">
//           <FullCalendar
//             plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
//             initialView="timeGridWeek"
//             headerToolbar={{
//               left: 'prev,next today',
//               center: 'title',
//               right: 'dayGridMonth,timeGridWeek,timeGridDay'
//             }}
//             events={machineScheduled}
//             height="100%"
//             slotMinTime="05:00:00"
//             slotMaxTime="18:00:00"
//             allDaySlot={false}
//             hiddenDays={[0]}
//             slotDuration="00:30:00"
//             slotLabelInterval="0:30:00"
//             editable={true}
//             droppable={true}
//             eventReceive={handleEventReceive}
//             eventDrop={handleEventDrop}
//             eventConstraint={{ startTime: '00:00:00', endTime: '23:59:59' }}
//             eventTextColor="black"
//             eventContent={(eventInfo) => {
//               const { event } = eventInfo;
//               const { extendedProps } = event;

//               if (extendedProps.isNote) {
//                 return (
//                   <div
//                     className="fc-event-main h-full w-full overflow-hidden p-1 text-xs leading-tight"
//                     style={{
//                       backgroundColor: event.backgroundColor || '#fffa65',
//                       borderColor: event.borderColor || '#fffa65',
//                       color: event.textColor || '#000',
//                       height: '100%',
//                       boxSizing: 'border-box'
//                     }}
//                   >
//                     <strong>Note:</strong>
//                     <div>{extendedProps.content || 'Empty note'}</div>
//                   </div>
//                 );
//               }

//               const hours = extendedProps.hours && !isNaN(parseFloat(extendedProps.hours))
//                 ? Number(extendedProps.hours).toFixed(2)
//                 : ((event.end - event.start) / (1000 * 60 * 60)).toFixed(2) || '1.00';

//               return (
//                 <div
//                   className="fc-event-main h-full w-full overflow-hidden p-1 text-xs leading-tight"
//                   style={{
//                     background: colorchange(extendedProps.status || extendedProps.currentstatus || 'On Incoming'),
//                     height: '100%',
//                     boxSizing: 'border-box',
//                     color: 'black'
//                   }}
//                 >
//                   <strong className="block truncate text-sm">
//                     {extendedProps.customer || 'N/A'}
//                   </strong>
//                   <div>Status: {extendedProps.status || extendedProps.currentstatus || 'On Incoming'}</div>
//                   <div>Job: {event.title || 'N/A'}</div>
//                   <div>Hours: {hours}</div>
//                   <div>Inks: {extendedProps.fink || 'N/A'} {extendedProps.bink ? ` / ${extendedProps.bink}` : ' / 0'}</div>
//                   <div>
//                     {extendedProps.sheetl && extendedProps.sheetw
//                       ? `${extendedProps.sheetl} X ${extendedProps.sheetw}`
//                       : 'N/A'}{' '}
//                     {extendedProps.method || 'N/A'} - {extendedProps.presstype || ''}  {/* ← shows presstype */}
//                   </div>
//                 </div>
//               );
//             }}
//             eventDidMount={(info) => {
//               const status = info.event.extendedProps.status || info.event.extendedProps.currentstatus || 'On Incoming';
//               const color = colorchange(status);
//               info.el.style.backgroundColor = color;
//               info.el.style.borderColor = color;
//               info.el.style.color = 'black';
//               info.el.style.overflow = 'hidden';
//               info.el.addEventListener('dblclick', () => handleEventDoubleClick(info));
//               info.el.title = [
//                 info.event.title,
//                 `Customer: ${info.event.extendedProps.customer || 'N/A'}`,
//                 `Status: ${info.event.extendedProps.status || info.event.extendedProps.currentstatus || 'On Incoming'}`,
//                 `Inks: ${info.event.extendedProps.fink || 'N/A'} / ${info.event.extendedProps.bink || 'N/A'}`,
//                 `Coating: ${info.event.extendedProps.faq || 'N/A'} / ${info.event.extendedProps.baq || 'N/A'}`,
//                 `Sheet: ${info.event.extendedProps.sheetl || 'N/A'} x ${info.event.extendedProps.sheetw || 'N/A'}`,
//                 `Method: ${info.event.extendedProps.method || 'N/A'}`,
//                 `Press Type: ${info.event.extendedProps.presstype || ''}`  // ← added here
//               ].join('\n');
//             }}
//           />
//         </div>

//         {/* Edit Modal */}
//         {isScheduleEditModalOpen && (
//           <>
//             <div className="modal-overlay" onClick={() => setIsScheduleEditModalOpen(false)}></div>
//             <div className="modal" style={{ padding: '20px', maxWidth: '550px' }}>
//               <div style={{ fontSize: 'clamp(1.3rem,1.3rem,1.5rem)', marginBottom: '20px' }}>
//                 {selectedEvent?.extendedProps.isNote ? 'Edit Note' : 'Edit Scheduled Job'}
//               </div>
//               <form onSubmit={handleScheduleEditSubmit} style={{ padding: '0 10px' }}>
//                 {selectedEvent?.extendedProps.isNote ? (
//                   <>
//                     <div style={{ marginBottom: '18px' }}>
//                       <label style={{ display: 'block', marginBottom: '6px', fontWeight: 500 }}>
//                         Start date & time
//                       </label>
//                       <input
//                         type="datetime-local"
//                         value={
//                           selectedEvent.start
//                             ? new Date(selectedEvent.start).toISOString().slice(0, 16)
//                             : ''
//                         }
//                         onChange={(e) => {
//                           const newStart = new Date(e.target.value);
//                           if (!isNaN(newStart.getTime())) {
//                             selectedEvent.setStart(newStart);
//                             setScheduleEditFormData(prev => ({ ...prev, start: newStart.toISOString() }));
//                           }
//                         }}
//                         style={{ width: '100%', padding: '9px', border: '1px solid #ccc', borderRadius: '5px', fontSize: '1rem' }}
//                       />
//                     </div>
//                     <div style={{ marginBottom: '18px' }}>
//                       <label style={{ display: 'block', marginBottom: '6px', fontWeight: 500 }}>
//                         Duration (hours)
//                       </label>
//                       <input
//                         type="number"
//                         value={
//                           selectedEvent.start && selectedEvent.end
//                             ? ((new Date(selectedEvent.end) - new Date(selectedEvent.start)) / (1000 * 60 * 60)).toFixed(2)
//                             : '1.00'
//                         }
//                         onChange={(e) => {
//                           const hours = parseFloat(e.target.value) || 1;
//                           if (selectedEvent.start) {
//                             const newEnd = new Date(selectedEvent.start);
//                             newEnd.setTime(newEnd.getTime() + hours * 60 * 60 * 1000);
//                             selectedEvent.setEnd(newEnd);
//                             setScheduleEditFormData(prev => ({ ...prev, end: newEnd.toISOString() }));
//                           }
//                         }}
//                         style={{ width: '100%', padding: '9px', border: '1px solid #ccc', borderRadius: '5px', fontSize: '1rem' }}
//                       />
//                     </div>
//                     <div style={{ marginBottom: '20px' }}>
//                       <label style={{ display: 'block', marginBottom: '6px', fontWeight: 500 }}>
//                         Note text
//                       </label>
//                       <textarea
//                         style={{ width: '100%', height: '140px', padding: '10px', border: '1px solid #ccc', borderRadius: '5px', resize: 'vertical', fontSize: '1rem' }}
//                         value={scheduleEditFormData.content || ''}
//                         onChange={e => setScheduleEditFormData(prev => ({ ...prev, content: e.target.value }))}
//                         placeholder="Enter or edit your note here..."
//                       />
//                     </div>
//                   </>
//                 ) : (
//                   <>
//                     <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
//                       <div style={{ flex: 1 }}>Customer:</div>
//                       <div style={{ flex: 2 }}>
//                         <input
//                           type="text"
//                           style={{ width: '100%' }}
//                           value={scheduleEditFormData.customer || ''}
//                           onChange={e => setScheduleEditFormData(prev => ({ ...prev, customer: e.target.value }))}
//                         />
//                       </div>
//                       <div style={{ flex: 1, textAlign: 'right', paddingRight: '10px' }}>Job:</div>
//                       <div style={{ flex: 2 }}>
//                         <input
//                           type="text"
//                           style={{ width: '100%' }}
//                           value={scheduleEditFormData.job || ''}
//                           onChange={e => setScheduleEditFormData(prev => ({ ...prev, job: e.target.value }))}
//                         />
//                       </div>
//                     </div>

//                     <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
//                       <div style={{ flex: 1 }}>Component:</div>
//                       <div style={{ flex: 3 }}>
//                         <input
//                           type="text"
//                           style={{ width: '100%' }}
//                           value={scheduleEditFormData.component || ''}
//                           onChange={e => setScheduleEditFormData(prev => ({ ...prev, component: e.target.value }))}
//                         />
//                       </div>
//                       <div style={{ flex: 2 }}>&nbsp;</div>
//                     </div>

//                     <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
//                       <div style={{ flex: 1 }}>Start Date & Time:</div>
//                       <div style={{ flex: 4 }}>
//                         <input
//                           type="datetime-local"
//                           style={{ width: '75%', padding: '5px 0px' }}
//                           value={scheduleEditFormData.start || ''}
//                           onChange={e => {
//                             const newStartStr = e.target.value;
//                             setScheduleEditFormData(prev => ({ ...prev, start: newStartStr }));
//                             if (selectedEvent && newStartStr) {
//                               const newStart = new Date(newStartStr);
//                               if (!isNaN(newStart.getTime())) {
//                                 const durationMs = selectedEvent.end - selectedEvent.start;
//                                 const newEnd = new Date(newStart.getTime() + durationMs);
//                                 selectedEvent.setStart(newStart);
//                                 selectedEvent.setEnd(newEnd);
//                               }
//                             }
//                           }}
//                         />
//                       </div>
//                     </div>

//                     <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
//                       <div style={{ flex: 1 }}>Press Machine:</div>
//                       <div style={{ flex: 4 }}>
//                         <select
//                           style={{ width: '75%', padding: '5px 0px' }}
//                           value={scheduleEditFormData.machine || currentMachine}
//                           onChange={e => setScheduleEditFormData(prev => ({ ...prev, machine: e.target.value }))}
//                         >
//                           <option value="GL440">GL440</option>
//                           <option value="GL540">GL540</option>
//                         </select>
//                       </div>
//                     </div>

//                     <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
//                       <div style={{ flex: 1 }}>FInk:</div>
//                       <div style={{ flex: 2 }}>
//                         <input
//                           type="text"
//                           style={{ width: '100%' }}
//                           value={scheduleEditFormData.fink || ''}
//                           onChange={e => setScheduleEditFormData(prev => ({ ...prev, fink: e.target.value }))}
//                         />
//                       </div>
//                       <div style={{ flex: 1, textAlign: 'right', paddingRight: '10px' }}>BInk:</div>
//                       <div style={{ flex: 2 }}>
//                         <input
//                           type="text"
//                           style={{ width: '100%' }}
//                           value={scheduleEditFormData.bink || ''}
//                           onChange={e => setScheduleEditFormData(prev => ({ ...prev, bink: e.target.value }))}
//                         />
//                       </div>
//                     </div>

//                     <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
//                       <div style={{ flex: 1 }}>Length:</div>
//                       <div style={{ flex: 2 }}>
//                         <input
//                           type="text"
//                           style={{ width: '100%' }}
//                           placeholder="Length"
//                           value={scheduleEditFormData.sheetl || ''}
//                           onChange={e => setScheduleEditFormData(prev => ({ ...prev, sheetl: e.target.value }))}
//                         />
//                       </div>
//                       <div style={{ flex: 1, textAlign: 'right', paddingRight: '10px' }}>Width:</div>
//                       <div style={{ flex: 2 }}>
//                         <input
//                           type="text"
//                           style={{ width: '100%' }}
//                           placeholder="Width"
//                           value={scheduleEditFormData.sheetw || ''}
//                           onChange={e => setScheduleEditFormData(prev => ({ ...prev, sheetw: e.target.value }))}
//                         />
//                       </div>
//                     </div>

//                     <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
//                       <div style={{ flex: 1 }}>Method:</div>
//                       <div style={{ flex: 2 }}>
//                         <select
//                           style={{ width: '100%', padding: '5px 0px' }}
//                           value={scheduleEditFormData.method || ''}
//                           onChange={e => setScheduleEditFormData(prev => ({ ...prev, method: e.target.value }))}
//                         >
//                           <option value="">Select Method</option>
//                           <option value="Sheetwise">Sheetwise</option>
//                           <option value="Work & Turn">Work & Turn</option>
//                           <option value="One-Sided">One-Sided</option>
//                           <option value="Perfect">Perfect</option>
//                           <option value="Work & Tumble">Work & Tumble</option>
//                         </select>
//                       </div>
//                       <div style={{ flex: 1, textAlign: 'right', paddingRight: '10px' }}>Hours:</div>
//                       <div style={{ flex: 2 }}>
//                         <input
//                           type="number"
//                           style={{ width: '100%' }}
//                           value={scheduleEditFormData.hours || '1'}
//                           onChange={e => setScheduleEditFormData(prev => ({ ...prev, hours: e.target.value }))}
//                         />
//                       </div>
//                     </div>

//                     <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
//                       <div style={{ flex: 1 }}>Status:</div>
//                       <div style={{ flex: 4 }}>
//                         <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
//                           <div style={{ flex: 1 }}>Status:</div>
//                           <div style={{ flex: 4 }}>
//                             <select
//                               style={{ width: '75%', padding: '5px 0px' }}
//                               value={scheduleEditFormData.status || 'On Incoming'}
//                               onChange={(e) => handleStatusChange(e.target.value)}
//                             >
//                               <option value="On Incoming">On Incoming</option>
//                               <option value="On Press">On Press</option>
//                               <option value="Off Press">Off Press</option>
//                               <option value="Ready Press">Ready Press</option>
//                               <option value="Incomplete Press">Incomplete Press</option>
//                               <option value="Press AA Changes">Press AA Changes</option>
//                             </select>
//                             <div
//                               style={{
//                                 display: 'inline-block',
//                                 width: '20px',
//                                 height: '20px',
//                                 backgroundColor: colorchange(scheduleEditFormData.status || 'On Incoming'),
//                                 border: '1px solid #888',
//                                 borderRadius: '4px',
//                                 marginLeft: '12px',
//                                 verticalAlign: 'middle',
//                               }}
//                             />
//                             <span style={{ marginLeft: '8px', fontSize: '0.95em', color: '#444' }}>
//                               {scheduleEditFormData.status || 'On Incoming'}
//                             </span>
//                           </div>
//                           <div style={{ flex: 1 }}>&nbsp;</div>
//                         </div>
//                       </div>
//                       <div style={{ flex: 1 }}>&nbsp;</div>
//                     </div>
//                   </>
//                 )}

//                 <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px', gap: '10px' }}>
//                   <button
//                     type="button"
//                     onClick={() => setIsScheduleEditModalOpen(false)}
//                     style={{ background: 'rgb(255,0,0,.7)', color: 'white', padding: '8px 20px', border: 'none', borderRadius: '4px' }}
//                   >
//                     Cancel

import { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Scroll } from '../../utilities/Shared';
// FullCalendar + Draggable
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin, { Draggable } from '@fullcalendar/interaction';
import { colorchange } from '../../utilities/Convertions';

const M110 = () => {
  const api = 'https://highgroundapi.herokuapp.com';
  const config = { headers: { 'Content-Type': 'application/json' } };
  const currentMachine = 'M110';
  const listItemsRef = useRef([]);

  const [rawJobs, setRawJobs] = useState([]);
  const [allScheduled, setAllScheduled] = useState([]);
  const [machineScheduled, setMachineScheduled] = useState([]);
  const [displayList, setDisplayList] = useState([]);
  const [sortOption, setSortOption] = useState('job');
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [scheduleEditFormData, setScheduleEditFormData] = useState({});
  const [isScheduleEditModalOpen, setIsScheduleEditModalOpen] = useState(false);
  const [isCreateNoteModalOpen, setIsCreateNoteModalOpen] = useState(false);
  const [createNoteForm, setCreateNoteForm] = useState({
    startDate: new Date().toISOString().slice(0, 16),
    durationHours: 0.5,
    content: '',
  });
  const [jobPressTimeMap, setJobPressTimeMap] = useState({});

  const channel = new BroadcastChannel('schedule-update');

  // Helper to determine presstype based on press value
  const getPressType = (press) => {
    const p = String(press);
    if (p === '5') return 'Folding';
    if (p === '6') return 'Sheeter';
    return ''; // default / unknown
  };

  // ── 1. Save / Edit ───────────────────────────────────────────────────────
  const handleScheduleEditSubmit = async (e) => {
    e.preventDefault();
    if (!selectedEvent) return;
    try {
      if (selectedEvent.extendedProps.isNote) {
        const content = scheduleEditFormData.content || '';
        const dbId = selectedEvent.extendedProps.dbId;
        const startStr = selectedEvent.start ? selectedEvent.start.toISOString() : null;
        const endStr = selectedEvent.end ? selectedEvent.end.toISOString() : null;
        let res;
        if (dbId) {
          res = await axios.post(`${api}/sched/updatecal`, {
            _id: dbId,
            start: startStr,
            end: endStr,
            content,
            isNote: true,
            machine: currentMachine
          });
        } else {
          res = await axios.post(`${api}/sched/add`, {
            start: startStr,
            end: endStr,
            content,
            isNote: true,
            machine: currentMachine
          });
          if (res.data?.schedule?._id || res.data?._id) {
            const newId = res.data.schedule?._id || res.data._id;
            selectedEvent.setProp('id', `db-${newId}`);
            selectedEvent.setExtendedProp('dbId', newId);
          } else {
            throw new Error("No _id returned from create");
          }
        }
        selectedEvent.setProp('title', content.trim() || 'Note');
        selectedEvent.setExtendedProp('content', content);
        setMachineScheduled(prev =>
          prev.map(e =>
            e.id === selectedEvent.id
              ? { ...e, start: startStr, end: endStr, title: content.trim() || 'Note', extendedProps: { ...e.extendedProps, content } }
              : e
          )
        );
        toast.success(dbId ? "Note updated" : "Note created");
        setIsScheduleEditModalOpen(false);
        return;
      }
      // Normal job handling
      const hrs = parseFloat(scheduleEditFormData.hours) || 0;
      // Use edited start time (or fallback to original)
      const newStart = scheduleEditFormData.start
        ? new Date(scheduleEditFormData.start)
        : selectedEvent.start;
      if (isNaN(newStart.getTime())) {
        toast.error("Invalid start date/time");
        return;
      }
      const newEnd = new Date(newStart);
      newEnd.setMinutes(newEnd.getMinutes() + hrs * 60);
      const payload = {
        _id: selectedEvent.extendedProps.dbId,
        job: scheduleEditFormData.job,
        component: scheduleEditFormData.component,
        fink: scheduleEditFormData.fink,
        bink: scheduleEditFormData.bink,
        sheetl: scheduleEditFormData.sheetl,
        sheetw: scheduleEditFormData.sheetw,
        faq: scheduleEditFormData.faq,
        baq: scheduleEditFormData.baq,
        method: scheduleEditFormData.method,
        hours: hrs,
        customer: scheduleEditFormData.customer,
        status: scheduleEditFormData.status,
        start: newStart.toISOString(),
        end: newEnd.toISOString(),
        machine: scheduleEditFormData.machine || currentMachine,
        presstype: scheduleEditFormData.presstype || getPressType(scheduleEditFormData.press || selectedEvent.extendedProps.press || '')
      };
      await axios.post(`${api}/sched/updatecal`, payload);
      // Update FullCalendar event
      selectedEvent.setStart(newStart);
      selectedEvent.setEnd(newEnd);
      // Update extended props (skip 'start' since we already set it via setStart)
      Object.entries(scheduleEditFormData).forEach(([key, val]) => {
        if (key !== 'start') {
          selectedEvent.setExtendedProp(key, val);
        }
      });
      selectedEvent.setProp(
        "title",
        `${scheduleEditFormData.job || "N/A"}${scheduleEditFormData.component ? ` - ${scheduleEditFormData.component}` : ""}`
      );
      // Update local machineScheduled state
      setMachineScheduled(prev =>
        prev.map(e =>
          e.id === selectedEvent.id
            ? {
                ...e,
                start: newStart.toISOString(),
                end: newEnd.toISOString(),
                extendedProps: {
                  ...e.extendedProps,
                  ...scheduleEditFormData,
                  start: newStart.toISOString()
                }
              }
            : e
        )
      );
      setIsScheduleEditModalOpen(false);
      toast.success("Schedule updated");
      window.location.reload(); // or use setRefreshTrigger(prev => prev + 1) instead
    } catch (err) {
      console.error(err);
      toast.error("Update failed");
    }
  };

  // ── 2. Duplicate ─────────────────────────────────────────────────────────
  const handleScheduleDuplicate = async () => {
    if (!selectedEvent) return;
    try {
      if (!selectedEvent.start || isNaN(selectedEvent.start.getTime())) {
        toast.error("Cannot duplicate: original event has invalid start time");
        return;
      }
      const originalStart = new Date(selectedEvent.start);
      const originalEnd = selectedEvent.end && !isNaN(selectedEvent.end.getTime())
        ? new Date(selectedEvent.end)
        : new Date(originalStart.getTime() + 60 * 60 * 1000);
      const duration = originalEnd - originalStart;
      if (duration <= 0) {
        toast.error("Cannot duplicate: event duration is zero or negative");
        return;
      }
      const newStart = new Date(originalStart);
      const newEnd = new Date(newStart.getTime() + duration);
      const payload = {
        ...selectedEvent.extendedProps,
        start: newStart,
        end: newEnd,
        machine: currentMachine
      };
      delete payload.dbId;
      delete payload._id;
      const res = await axios.post(`${api}/sched/add`, payload);
      const newDbId = res.data._id;
      if (!newDbId) throw new Error("Failed to get _id from server");
      const newEvent = {
        id: `db-${newDbId}`,
        title: selectedEvent.title,
        start: newStart.toISOString(),
        end: newEnd.toISOString(),
        extendedProps: {
          ...payload,
          dbId: newDbId
        },
        backgroundColor: selectedEvent.backgroundColor,
        borderColor: '#000',
        textColor: '#000'
      };
      setMachineScheduled(prev => [...prev, newEvent]);
      setIsScheduleEditModalOpen(false);
      toast.success("Duplicated successfully");
    } catch (err) {
      console.error("Duplicate failed:", err);
      toast.error("Duplicate failed");
    }
  };

  console.log(machineScheduled)
  // ── 3. Delete ────────────────────────────────────────────────────────────
  const handleScheduleRemove = async () => {
    if (!selectedEvent) return;
    try {
      const dbId = selectedEvent.extendedProps.dbId;
      if (!dbId) {
        selectedEvent.remove();
        setMachineScheduled(prev => prev.filter(e => e.id !== selectedEvent.id));
        toast.success("Note removed (was never saved)");
        setIsScheduleEditModalOpen(false);
        setRefreshTrigger(prev => prev + 1);
        channel.postMessage('refresh');
        return;
      }
      await axios.post(`${api}/sched/remove`, { id: dbId });
      selectedEvent.remove();
      setMachineScheduled(prev => prev.filter(e => e.extendedProps.dbId !== dbId));
      setIsScheduleEditModalOpen(false);
      toast.success(selectedEvent.extendedProps.isNote ? "Note deleted" : "Schedule deleted");
      setRefreshTrigger(prev => prev + 1);
      window.location.reload();
      channel.postMessage('refresh');
    } catch (err) {
      console.error("Delete failed:", err);
      toast.error("Delete failed");
    }
  };

  // ── Double-click to edit ─────────────────────────────────────────────────
  const handleEventDoubleClick = (info) => {
    const ev = info.event;
    setSelectedEvent(ev);
    if (ev.extendedProps.isNote) {
      setScheduleEditFormData({
        content: ev.extendedProps.content || '',
        start: ev.start,
        end: ev.end
      });
    } else {
      setScheduleEditFormData({
        job: ev.extendedProps.job || '',
        component: ev.extendedProps.component || '',
        fink: ev.extendedProps.fink || '',
        bink: ev.extendedProps.bink || '',
        faq: ev.extendedProps.faq || '',
        baq: ev.extendedProps.baq || '',
        sheetl: ev.extendedProps.sheetl || '',
        sheetw: ev.extendedProps.sheetw || '',
        method: ev.extendedProps.method || '',
        hours: ev.extendedProps.hours || ((ev.end - ev.start) / (1000 * 60 * 60)).toFixed(2),
        customer: ev.extendedProps.customer || '',
        status: ev.extendedProps.status || ev.extendedProps.currentstatus || 'On Incoming',
        machine: ev.extendedProps.machine || currentMachine,
        start: ev.start
          ? `${ev.start.getFullYear()}-${String(ev.start.getMonth() + 1).padStart(2, '0')}-${String(ev.start.getDate()).padStart(2, '0')}T${String(ev.start.getHours()).padStart(2, '0')}:${String(ev.start.getMinutes()).padStart(2, '0')}`
          : ''
      });
    }
    setIsScheduleEditModalOpen(true);
  };

  // ── Fetch open jobs ──────────────────────────────────────────────────────
  useEffect(() => {
    const fetchActiveJobs = async () => {
      try {
        const res = await axios.post('https://highgroundapi.herokuapp.com/jobs/openjobs');
        setRawJobs(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        toast.error('Failed to load open jobs');
        setRawJobs([]);
      }
    };
    fetchActiveJobs();
  }, []);

  const fetchScheduled = async () => {
    try {
      const res = await axios.post(`${api}/sched/sheetfed`, { machine: ['M110'] });
      const data = Array.isArray(res.data) ? res.data : [];
      setAllScheduled(data.map(item => ({
        job: String(item.job || '').trim(),
        component: String(item.component || '').trim(),
        presstype:String(item.presstype)
      })));
      let machineEvents = data
        .filter(item => String(item.machine || '').trim() === currentMachine)
        .map(item => {
          if (item.isNote) {
            const start = new Date(item.start);
            const end = item.end ? new Date(item.end) : new Date(start.getTime() + 60*60*1000);
            return {
              id: `db-${item._id}`,
              title: 'Note',
              start: start.toISOString(),
              end: end.toISOString(),
              extendedProps: {
                isNote: true,
                content: item.content || '',
                hours: 1,
                dbId: item._id,
                customer: item.customer || 'N/A',
                status: 'Note',
              },
              backgroundColor: '#fffa65',
              borderColor: '#fffa65',
              textColor: '#000'
            };
          }
          const start = item.start ? new Date(item.start) : null;
          const end = item.end ? new Date(item.end) : null;
          const eventId = item._id ? `db-${item._id}` : `${item.job}-${item.component || 'no-comp'}-${start?.getTime() || 'no-start'}`;
          return {
            id: eventId,
            title: `${item.job || 'N/A'}${item.component ? ` - ${item.component}` : ''}`,
            start: start?.toISOString() ?? null,
            end: end?.toISOString() ?? null,
            extendedProps: {
              job: item.job,
              component: item.component,
              customer: item.customer || 'N/A',
              status: item.status || 'Scheduled',
              currentstatus: item.currentstatus || item.status || 'Scheduled',
              fink: item.fink || '',
              bink: item.bink || '',
              faq: item.faq || '',
              baq: item.baq || '',
              sheetl: item.sheetl || '',
              sheetw: item.sheetw || '',
              method: item.method || '',
              dbId: item._id,
              presstype: getPressType(item.press)  // ← ADDED HERE (fixes the issue)
            },
            backgroundColor: colorchange(item.status || 'Scheduled'),
            borderColor: '#000',
            textColor: '#000'
          };
        })
        .filter(e => e.start);
      if (machineEvents.length > 0) {
        const payload = {
          items: machineEvents.map(e => ({
            job: e.extendedProps.job || '',
            component: e.extendedProps.component || null
          })).filter(i => i.job)
        };
        if (payload.items.length > 0) {
          try {
            const resStatus = await axios.post(`https://highgroundsoftware.com/dash/dashboard/php/getnewoperations.php`, payload, config);
            if (resStatus.data.success) {
              const statusMap = {};
              resStatus.data.results?.forEach(r => {
                statusMap[`${r.job}|${r.component || 'NULL'}`] = r.name || 'Scheduled';
              });
              machineEvents = machineEvents.map(e => {
                const key = `${e.extendedProps.job}|${e.extendedProps.component || 'NULL'}`;
                if (statusMap[key]) {
                  const newStatus = statusMap[key];
                  return {
                    ...e,
                    extendedProps: { ...e.extendedProps, status: newStatus, currentstatus: newStatus },
                    backgroundColor: colorchange(newStatus)
                  };
                }
                return e;
              });
            }
          } catch (err) {
            // silent fail
          }
        }
      }
      // NEW: Ensure presstype is always set (fallback if backend misses press)
      machineEvents = machineEvents.map(event => {
        if (event.extendedProps.isNote) return event; // skip notes

        const press = event.extendedProps.press || ''; // already there from draggable, or fallback
        return {
          ...event,
          extendedProps: {
            ...event.extendedProps,
            presstype: event.extendedProps.presstype || getPressType(press) // use existing or calculate
          }
        };
      });

      setMachineScheduled(machineEvents);
      //setMachineScheduled(machineEvents);
    } catch (err) {
      toast.error('Failed to load scheduled jobs');
      setAllScheduled([]);
      setMachineScheduled([]);
    }
  };

  useEffect(() => {
    fetchScheduled();
  }, []);

  // ── Expand + filter + sort + real status + PRESS TIME + per-form split ───
  useEffect(() => {
    const expanded = [];
    rawJobs.forEach(job => {
      const impositions = job.imposition || [];
      impositions.forEach(impo => {
        const pressNum = Number(impo.press) || 0;
        if (pressNum !== 5 && pressNum !== 6) return;
        const numForms = Number(impo.numforms) || 1;
        for (let i = 1; i <= numForms; i++) {
          let displayComponent = impo.component || 'N/A';
          if (numForms > 1) displayComponent = `${i}) ${displayComponent}`;
          expanded.push({
            ...job,
            ...impo,
            formIndex: i,
            _displayPrefix: numForms > 1 ? `${i}) ` : '',
            displayComponent,
            originalComponent: impo.component || 'N/A',
            status: impo.status || job.status || 'On Incoming',
            currentstatus: impo.currentstatus || job.currentstatus || 'On Incoming',
            presstime1: impo.presstime1 || '1',
            numforms: numForms
          });
        }
      });
    });
    let sorted = [...expanded];
    if (sortOption === 'dueDate') {
      sorted.sort((a, b) => new Date(a.duedate || '9999') - new Date(b.duedate || '9999'));
    } else if (sortOption === 'customer') {
      sorted.sort((a, b) => (a.customer || '').localeCompare(b.customer || ''));
    } else {
      sorted.sort((a, b) => (a.job || '').localeCompare(b.job || ''));
    }
    const filtered = sorted.filter(item => {
      const jobStr = String(item.job || '').trim();
      const compStr = String(item.originalComponent || item.component || '').trim();
      return !allScheduled.some(s =>
        String(s.job).trim() === jobStr && String(s.component).trim() === compStr
      );
    });
    const applyRealStatusAndTimes = async () => {
      let updated = [...filtered];
      // Real status fetch (unchanged)
      const statusPayload = {
        items: filtered.map(item => ({
          job: String(item.job || '').trim(),
          component: String(item.displayComponent || item.component || '').trim() || null
        })).filter(i => i.job)
      };
      if (statusPayload.items.length > 0) {
        try {
          const res = await axios.post(`https://highgroundsoftware.com/dash/dashboard/php/getnewoperations.php`, statusPayload, config);
          if (res.data.success) {
            const statusMap = {};
            res.data.results?.forEach(r => {
              statusMap[`${r.job}|${r.component || 'NULL'}`] = r.name || 'On Incoming';
            });
            updated.forEach(item => {
              const key = `${String(item.job || '').trim()}|${String(item.displayComponent || item.component || '').trim() || 'NULL'}`;
              if (statusMap[key]) {
                item.currentstatus = statusMap[key];
                item.status = statusMap[key];
              }
            });
          }
        } catch (err) {
          // silent fail
        }
      }
      // Press time fetch - build per-component map + total fallback
      const uniqueQuotes = [...new Set(updated.map(item => String(item.quote || '').trim()).filter(Boolean))];
      let fetchedTimeMap = {}; // quote → total (fallback)
      let componentTimeMap = {}; // quote → { "COVER": 6, "FORM 04PG": 4.5, ... }
      if (uniqueQuotes.length > 0) {
        try {
          const timeRes = await axios.post(
            `https://highgroundsoftware.com/dash/dashboard/php/getpresstimes.php`,
            { jobs: uniqueQuotes },
            config
          );
       
          if (Array.isArray(timeRes.data)) {
            timeRes.data.forEach(row => {
              const quoteKey = String(row.quote || row.Quote || '').trim();
              if (!quoteKey) return;
              const compKey = String(row.component || '').trim().toUpperCase();
              const t1 = parseFloat(row.presstime1) || 0;
              const t2 = parseFloat(row.presstime2) || 0;
              const totalForRow = t1 + t2;
              // Store per-component (prefer t1 as main press time)
              if (compKey) {
                if (!componentTimeMap[quoteKey]) componentTimeMap[quoteKey] = {};
                componentTimeMap[quoteKey][compKey] = t1 || totalForRow;
               
              }
              // Accumulate total for fallback
              if (!fetchedTimeMap[quoteKey]) fetchedTimeMap[quoteKey] = 0;
              fetchedTimeMap[quoteKey] += totalForRow;
            });
          }
        } catch (err) {
          console.warn("Failed to load press times per job", err);
        }
      }
      setJobPressTimeMap(fetchedTimeMap);
      // Assign time: match by component first, then split evenly if numforms > 1
      updated = updated.map(item => {
        const quoteKey = String(item.quote || '').trim();
        const compName = String(item.component || item.originalComponent || '').trim().toUpperCase();
        const numForms = Number(item.numforms) || 1;
        let hoursThisForm = 1.5; // default fallback
        // 1. Get the base time for this component
        let baseTime = 1.5;
        if (componentTimeMap[quoteKey] && componentTimeMap[quoteKey][compName] > 0) {
          baseTime = componentTimeMap[quoteKey][compName];
         
        }
        else if (fetchedTimeMap[quoteKey] > 0) {
          const impositionCount = updated.filter(i => String(i.quote || '').trim() === quoteKey).length || 1;
          baseTime = fetchedTimeMap[quoteKey] / impositionCount;
         
        }
        else {
         
        }
        // 2. Split evenly if numforms > 1
        if (numForms > 1) {
          hoursThisForm = baseTime / numForms;
          console.log(`Split ${baseTime.toFixed(2)} hr across ${numForms} forms → ${hoursThisForm.toFixed(2)} hr per form`);
        } else {
          hoursThisForm = baseTime;
        }
        return { ...item, pressTimePerForm: hoursThisForm };
      });
      const finalList = updated.filter(openItem => {
        const openJob = String(openItem.job || '').trim();
        const openComp = String(openItem.displayComponent || openItem.component || '').trim();
        return !machineScheduled.some(sched => {
          const schedJob = String(sched.extendedProps.job || '').trim();
          const schedComp = String(sched.extendedProps.component || '').trim();
          return schedJob === openJob && schedComp === openComp;
        }) &&
        !allScheduled.some(s => {
          const sJob = String(s.job || '').trim();
          const sComp = String(s.component || '').trim();
          return sJob === openJob && sComp === openComp;
        });
      });
      setDisplayList(finalList);
    };
    applyRealStatusAndTimes();
  }, [rawJobs, allScheduled, sortOption, machineScheduled, refreshTrigger]);

  useEffect(() => {
    channel.onmessage = (event) => {
      if (event.data === 'refresh') {
        fetchScheduled();
      }
    };
    return () => {
      channel.close();
    };
  }, []);

  console.log(displayList)

  // ── Make open items draggable ────────────────────────────────────────────
  useEffect(() => {
    const draggables = [];
    listItemsRef.current.forEach((el, idx) => {
      if (!el || !displayList[idx]) return;
      const item = displayList[idx];
      const hours = parseFloat(item.pressTimePerForm) || 1.5;
      const draggable = new Draggable(el, {
        eventData: {
          title: `${item.job || 'N/A'}${item.displayComponent ? ` - ${item.displayComponent}` : ''}`,
          duration: `${Math.floor(hours)}:${Math.round((hours % 1) * 60).toString().padStart(2, '0')}:00`,
          extendedProps: {
            customer: item.customer || 'N/A',
            status: item.status || 'On Incoming',
            currentstatus: item.currentstatus || 'On Incoming',
            hours: hours.toString(),
            component: item.displayComponent || item.component || null,
            job: item.job || '',
            fink: item.fink || '',
            bink: item.bink || '',
            faq: item.faq || '',
            baq: item.baq || '',
            sheetl: item.sheetl || '',
            sheetw: item.sheetw || '',
            method: item.method || '',
            _id: null,
            press: item.press || '',
            presstype: getPressType(item.press) // ← already here
          }
        }
      });
      draggables.push(draggable);
    });
    return () => draggables.forEach(d => d.destroy());
  }, [displayList]);

  // ── Handle event drop ────────────────────────────────────────────────────
  const handleEventDrop = async (info) => {
    const event = info.event;
    if (!event.start || isNaN(event.start.getTime())) {
      console.warn("Invalid drop - start is null or invalid", event);
      info.revert();
      toast.error("Cannot drop here (outside allowed time range)");
      return;
    }
    const safeEnd = event.end && !isNaN(event.end.getTime())
      ? event.end
      : new Date(event.start.getTime() + 60 * 60 * 1000);
    const dbId = event.extendedProps.dbId;
    const isNote = !!event.extendedProps.isNote;
    const payload = {
      _id: dbId,
      machine: currentMachine,
      start: event.start.toISOString(),
      end: safeEnd.toISOString(),
      isNote: isNote,
    };
    if (!isNote) {
      payload.job = event.extendedProps.job || event.title.split(' - ')[0] || '';
      payload.component = event.extendedProps.component || '';
      payload.customer = event.extendedProps.customer || '';
      payload.status = event.extendedProps.status || event.extendedProps.currentstatus || 'On Incoming';
      payload.hours = ((safeEnd - event.start) / (1000 * 60 * 60)).toFixed(2);
      payload.fink = event.extendedProps.fink || '';
      payload.bink = event.extendedProps.bink || '';
      payload.faq = event.extendedProps.faq || '';
      payload.baq = event.extendedProps.baq || '';
      payload.sheetl = event.extendedProps.sheetl || '';
      payload.sheetw = event.extendedProps.sheetw || '';
      payload.method = event.extendedProps.method || '';
      payload.presstype = event.extendedProps.presstype || ''; // ← already here
    } else {
      payload.content = event.extendedProps.content || '';
    }
    try {
      const res = await axios.post(`${api}/sched/updatecal`, payload);
      if (res.data.success || res.data._id) {
        toast.success('Event moved and saved');
        setMachineScheduled(prev =>
          prev.map(e =>
            e.id === event.id
              ? { ...e, start: event.start, end: safeEnd }
              : e
          )
        );
      } else {
        throw new Error('Save failed');
      }
    } catch (err) {
      console.error(err);
      toast.error('Failed to save moved event');
      info.revert();
    }
  };

  // ── Handle modal save (unused) ───────────────────────────────────────────
  const handleModalSave = async () => {
    const event = selectedEvent;
    let dbId;
    if (event.id.startsWith('db-')) {
      dbId = event.id.replace('db-', '');
    }
    const payload = {
      _id: dbId,
      machine: currentMachine,
      job: event.extendedProps.job,
      component: event.extendedProps.component,
      start: event.start.toISOString(),
      end: event.end.toISOString(),
      customer: event.extendedProps.customer,
      status: event.extendedProps.status
    };
    try {
      await axios.post(`${api}/sched/updatecal`, payload);
      setMachineScheduled(prev =>
        prev.map(e =>
          e.id === event.id
            ? { ...e, extendedProps: event.extendedProps }
            : e
        )
      );
      toast.success('Updated');
      setIsScheduleEditModalOpen(false);
    } catch (err) {
      toast.error('Update failed');
    }
  };

  // ── Handle drop from left to calendar ────────────────────────────────────
  const handleEventReceive = async (info) => {
    console.log('handleEventReceive triggered');
    const draggedEl = info.draggedEl;
    if (!draggedEl) {
      console.log('No draggedEl');
      toast.error('Drag failed - try again');
      info.revert();
      return;
    }
    let itemIndex = -1;
    if (draggedEl.parentNode) {
      itemIndex = Array.from(draggedEl.parentNode.children).indexOf(draggedEl);
    }
    if (itemIndex === -1) {
      const job = draggedEl.dataset.job;
      const component = draggedEl.dataset.component;
      console.log('Fallback lookup - job:', job, 'component:', component);
      if (job) {
        itemIndex = displayList.findIndex(item =>
          item.job === job &&
          (item.originalComponent || item.component) === component
        );
      }
    }
    console.log('Found itemIndex:', itemIndex);
    const item = itemIndex >= 0 ? displayList[itemIndex] : null;
    if (!item) {
      console.log('No item found in displayList');
      toast.error('Item not found');
      info.revert();
      return;
    }
    console.log('Dragged item data:', {
      job: item.job,
      component: item.component,
      originalComponent: item.originalComponent,
      displayComponent: item.displayComponent,
      numforms: item.numforms
    });
    const start = info.event.start;
    const hours = parseFloat(item.pressTimePerForm) || 1;
    const end = new Date(start);
    end.setHours(end.getHours() + hours);
    // Choose component to save
    let savedComponent;
    const numForms = Number(item.numforms) || 1;
    if (numForms > 1) {
      savedComponent = item.displayComponent || item.component || 'N/A';
      console.log('Multi-form → using prefixed:', savedComponent);
    } else {
      savedComponent = item.originalComponent || item.component || 'N/A';
      console.log('Single-form → using clean:', savedComponent);
    }
    const newEvent = {
      id: `${item.job}-${savedComponent}-${start.toISOString()}`,
      title: `${item.job || 'N/A'} - ${savedComponent}`,
      start: start.toISOString(),
      end: end.toISOString(),
      extendedProps: {
        customer: item.customer || 'N/A',
        status: item.status || 'On Incoming',
        currentstatus: item.currentstatus || 'On Incoming',
        hours: hours.toString(),
        component: savedComponent,
        originalComponent: item.originalComponent || item.component || null,
        job: item.job,
        fink: item.fink || '',
        bink: item.bink || '',
        faq: item.faq || '',
        baq: item.baq || '',
        sheetl: item.sheetl || '',
        sheetw: item.sheetw || '',
        method: item.method || '',
        presstype: getPressType(item.press) // ← already here
      },
      backgroundColor: colorchange(item.status || 'On Incoming'),
      borderColor: '#000',
      textColor: '#000'
    };
    try {
      const payload = {
        machine: currentMachine,
        job: newEvent.extendedProps.job,
        component: newEvent.extendedProps.component,
        start: newEvent.start,
        end: newEvent.end,
        customer: newEvent.extendedProps.customer,
        status: newEvent.extendedProps.status,
        hours: newEvent.extendedProps.hours,
        fink: newEvent.extendedProps.fink,
        bink: newEvent.extendedProps.bink,
        faq: newEvent.extendedProps.faq,
        baq: newEvent.extendedProps.baq,
        sheetl: newEvent.extendedProps.sheetl,
        sheetw: newEvent.extendedProps.sheetw,
        method: newEvent.extendedProps.method,
        presstype: newEvent.extendedProps.presstype // ← already here
      };
      console.log('Sending payload to /sched/add:', payload);
      const res = await axios.post(`${api}/sched/add`, payload, config);
      console.log('Server response:', res.data);
      if (res.data._id || res.data.success) {
        newEvent.id = `db-${res.data._id}`;
        newEvent.extendedProps.dbId = res.data._id;
        setMachineScheduled(prev => [...prev, newEvent]);
        setDisplayList(prev => prev.filter((_, idx) => idx !== itemIndex));
        toast.success('Event added to schedule');
      } else {
        console.log('Save failed - no _id or success in response');
        throw new Error('Save failed - no ID or success returned');
      }
    } catch (err) {
      console.error('Save error details:', err.response?.data || err.message);
      toast.error('Failed to save event');
      info.revert();
    }
  };

  const handleStatusChange = async (newStatus) => {
    if (!selectedEvent) return;
    const oldStatus = scheduleEditFormData.status || 'On Incoming';
    // Optimistic preview in UI & calendar
    setScheduleEditFormData(prev => ({
      ...prev,
      status: newStatus,
      currentstatus: newStatus,
    }));
    if (!selectedEvent.extendedProps.isNote) {
      selectedEvent.setExtendedProp('status', newStatus);
      selectedEvent.setExtendedProp('currentstatus', newStatus);
      selectedEvent.setProp('backgroundColor', colorchange(newStatus));
      selectedEvent.setProp('textColor', 'black');
    }
    // Prepare payload similar to your full save, but focused/minimal
    const payload = {
      // Required / important fields your PHP binds
      job: parseInt(selectedEvent.extendedProps.job) || parseInt(scheduleEditFormData.job) || '',
      comp: selectedEvent.extendedProps.component || scheduleEditFormData.component || '',
      process: parseInt(selectedEvent.extendedProps.process) || 3,
      status: newStatus,
      changedby: 1,
      name: selectedEvent.extendedProps.name || newStatus,
      item: parseInt(selectedEvent.extendedProps.item) || 0,
      partof: parseInt(selectedEvent.extendedProps.partof) || 0,
      partofid: parseInt(selectedEvent.extendedProps.partofid) || null,
      dept: parseInt(selectedEvent.extendedProps.dept) || 3,
      pages: parseInt(selectedEvent.extendedProps.pages) || 0,
      up: parseInt(selectedEvent.extendedProps.up) || 0,
      forms: parseInt(selectedEvent.extendedProps.forms) || 0,
      press: parseInt(selectedEvent.extendedProps.press) || 0,
      sheetl: parseInt(selectedEvent.extendedProps.sheetl) || 0,
      sheetw: parseInt(selectedEvent.extendedProps.sheetw) || 0,
      method: selectedEvent.extendedProps.method || '',
      versions: parseInt(selectedEvent.extendedProps.versions) ||1,
      mr: parseInt(selectedEvent.extendedProps.mr) || 0,
      cuts: parseInt(selectedEvent.extendedProps.cuts) || 0,
      foldtype: parseInt(selectedEvent.extendedProps.foldtype) || 0,
      topress: parseInt(selectedEvent.extendedProps.topress) || 0,
      push: parseInt(selectedEvent.extendedProps.push) || 0,
    };
    try {
      console.log(payload)
      const res = await axios.post(`https://highgroundsoftware.com/dash/dashboard/php/addoperation.php`, payload, config);
      console.log(res.data)
      if (res.data?.success || res.data?._id) {
        toast.success(`Status changed to ${newStatus} (new entry created)`);
        // fetchScheduled();
        channel.postMessage('refresh');
      } else {
        throw new Error("No success or new ID returned");
      }
    } catch (err) {
      console.error("Status add failed:", err);
      toast.error("Failed to record new status");
      // Rollback UI preview
      setScheduleEditFormData(prev => ({
        ...prev,
        status: oldStatus,
        currentstatus: oldStatus,
      }));
      if (!selectedEvent.extendedProps.isNote) {
        selectedEvent.setExtendedProp('status', oldStatus);
        selectedEvent.setExtendedProp('currentstatus', oldStatus);
        selectedEvent.setProp('backgroundColor', colorchange(oldStatus));
      }
    }
  };

  // ── JSX ──────────────────────────────────────────────────────────────────
  return (
    <div className="flex h-screen bg-gray-50">
      {/* Left sidebar - Open Jobs */}
      <div className="w-1/4 border-r border-gray-300 p-4 flex flex-col">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold">Open Jobs</h3>
          <span className="text-sm text-gray-600">{displayList.length} items</span>
        </div>
        <div className="mb-3 flex items-center gap-2">
          <label className="text-sm font-medium">Sort by:</label>
          <select
            value={sortOption}
            onChange={e => setSortOption(e.target.value)}
            className="border rounded px-2 py-1 text-sm"
          >
            <option value="job">Job #</option>
            <option value="dueDate">Due Date</option>
            <option value="customer">Customer</option>
          </select>
        </div>
        <Scroll className="flex-1">
          {displayList.length > 0 ? (
            displayList.map((item, idx) => (
              <div
                key={`${item.job}-${item.originalComponent}-${item.formIndex}-${idx}`}
                ref={el => (listItemsRef.current[idx] = el)}
                className="draggable-item p-3 mb-2 bg-white border border-gray-200 rounded shadow-sm hover:shadow-md cursor-move transition"
                style={{ backgroundColor: colorchange(item.currentstatus || item.status || 'On Incoming') }}
                data-job={item.job}
                data-component={item.originalComponent || item.component || ''}
              >
                <div className="font-bold text-base">
                  {item._displayPrefix}{item.customer || 'Unknown Customer'}
                </div>
                <div className="mt-1">
                  Job: <strong>{item.job || 'N/A'}</strong>
                  {' - '}
                  <span className={item.numforms > 1 ? 'text-blue-700 font-medium' : ''}>
                    {item.displayComponent || item.component || 'N/A'}
                  </span>
                  {item.numforms > 1 && (
                    <span className="text-sm text-gray-500 ml-1">(of {item.numforms})</span>
                  )}
                </div>
                <div className="mt-1">
                  Status: <strong>{item.currentstatus || item.status || 'On Incoming'}</strong>
                </div>
                <div className="text-sm text-gray-600 mt-1">
                  Due: {item.duedate ? new Date(item.duedate).toLocaleDateString() : '—'}
                  {' • Press: '}
                </div>
                <div className="mt-1">
                  Press time: <strong>{item.pressTimePerForm?.toFixed(2) ?? '—'}</strong> hr
                  {item.numforms > 1 && <span className="text-gray-500 ml-1">(per form)</span>}
                </div>
                <div className="mt-1">
                  Sheet: {item.sheetl || '?'} × {item.sheetw || '?'}
                  <br />
                  Inks: {item.fink || '—'} {item.bink ? `/ ${item.bink}` : ''}
                  <br />
                  <span
                    style={{
                      background: item.faq || item.baq ? "teal" : "inherit",
                      padding: '0px 40px 0px 0px',
                      color: item.faq || item.baq ? "white" : "inherit"
                    }}
                  >
                    Coating: {item.faq || '—'} {item.baq ? `/ ${item.baq}` : ''}
                  </span>
                  <br />
                  <span>Method: {item.method || '—'} - {item.press === "5" ? "Folding" : ""}{item.press === "6" ? "Sheeter" : ""}</span>
                </div>
              </div>
            ))
          ) : (
            <div className="p-8 text-center text-gray-500">
              {rawJobs.length === 0 ? 'Loading open jobs...' : 'No open jobs available'}
            </div>
          )}
        </Scroll>
      </div>

      {/* Right side - Calendar */}
      <div className="flex-1 p-6 flex flex-col">
        <h2 className="text-2xl font-bold mb-4">{currentMachine} Schedule</h2>

        <button
          style={{ background: '#2969ae', color: 'white', padding: '8px 20px', border: 'none', borderRadius: '4px', width: '15%' }}
          onClick={() => {
            const today = new Date();
            const defaultStart = new Date(
              today.getFullYear(),
              today.getMonth(),
              today.getDate(),
              7,
              0,
              0
            );
            const formatted = defaultStart.toISOString().slice(0, 16);
            setCreateNoteForm({
              startDate: formatted,
              durationHours: 1,
              content: '',
            });
            setIsCreateNoteModalOpen(true);
          }}
        >
          Add Note
        </button>

        <div className="flex-1 bg-white border rounded overflow-hidden mt-4">
          <FullCalendar
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            initialView="timeGridWeek"
            headerToolbar={{
              left: 'prev,next today',
              center: 'title',
              right: 'dayGridMonth,timeGridWeek,timeGridDay'
            }}
            events={machineScheduled}
            height="100%"
            slotMinTime="05:00:00"
            slotMaxTime="18:00:00"
            allDaySlot={false}
            slotDuration="00:30:00"
            slotLabelInterval="0:30:00"
            editable={true}
            droppable={true}
            eventReceive={handleEventReceive}
            eventDrop={handleEventDrop}
            eventConstraint={{ startTime: '00:00:00', endTime: '23:59:59' }}
            eventTextColor="black"
            eventContent={(eventInfo) => {
              const { event } = eventInfo;
              const { extendedProps } = event;

              if (extendedProps.isNote) {
                return (
                  <div
                    className="fc-event-main h-full w-full overflow-hidden p-1 text-xs leading-tight"
                    style={{
                      backgroundColor: event.backgroundColor || '#fffa65',
                      borderColor: event.borderColor || '#fffa65',
                      color: event.textColor || '#000',
                      height: '100%',
                      boxSizing: 'border-box'
                    }}
                  >
                    <strong>Note:</strong>
                    <div>{extendedProps.content || 'Empty note'}</div>
                  </div>
                );
              }

              const hours = extendedProps.hours && !isNaN(parseFloat(extendedProps.hours))
                ? Number(extendedProps.hours).toFixed(2)
                : ((event.end - event.start) / (1000 * 60 * 60)).toFixed(2) || '1.00';

              return (
                <div
                  className="fc-event-main h-full w-full overflow-hidden p-1 text-xs leading-tight"
                  style={{
                    background: colorchange(extendedProps.status || extendedProps.currentstatus || 'On Incoming'),
                    height: '100%',
                    boxSizing: 'border-box',
                    color: 'black'
                  }}
                >
                  <strong className="block truncate text-sm">
                    {extendedProps.customer || 'N/A'}
                  </strong>
                  <div>Status: {extendedProps.status || extendedProps.currentstatus || 'On Incoming'}</div>
                  <div>Job: {event.title || 'N/A'}</div>
                  <div>Hours: {hours}</div>
                  <div>Inks: {extendedProps.fink || 'N/A'} {extendedProps.bink ? ` / ${extendedProps.bink}` : ' / 0'}</div>
                  <div>
                    {extendedProps.sheetl && extendedProps.sheetw
                      ? `${extendedProps.sheetl} X ${extendedProps.sheetw}`
                      : 'N/A'}{' '}
                    {extendedProps.method || 'N/A'} - {extendedProps.presstype || ''} {/* ← shows presstype */}
                  </div>
                </div>
              );
            }}
            eventDidMount={(info) => {
              const status = info.event.extendedProps.status || info.event.extendedProps.currentstatus || 'On Incoming';
              const color = colorchange(status);
              info.el.style.backgroundColor = color;
              info.el.style.borderColor = color;
              info.el.style.color = 'black';
              info.el.style.overflow = 'hidden';
              info.el.addEventListener('dblclick', () => handleEventDoubleClick(info));
              info.el.title = [
                info.event.title,
                `Customer: ${info.event.extendedProps.customer || 'N/A'}`,
                `Status: ${info.event.extendedProps.status || info.event.extendedProps.currentstatus || 'On Incoming'}`,
                `Inks: ${info.event.extendedProps.fink || 'N/A'} / ${info.event.extendedProps.bink || 'N/A'}`,
                `Coating: ${info.event.extendedProps.faq || 'N/A'} / ${info.event.extendedProps.baq || 'N/A'}`,
                `Sheet: ${info.event.extendedProps.sheetl || 'N/A'} x ${info.event.extendedProps.sheetw || 'N/A'}`,
                `Method: ${info.event.extendedProps.method || 'N/A'}`,
                `Press Type: ${info.event.extendedProps.presstype || ''}` // ← added here
              ].join('\n');
            }}
          />
        </div>

        {/* Edit Modal */}
        {isScheduleEditModalOpen && (
          <>
            <div className="modal-overlay" onClick={() => setIsScheduleEditModalOpen(false)}></div>
            <div className="modal" style={{ padding: '20px', maxWidth: '550px' }}>
              <div style={{ fontSize: 'clamp(1.3rem,1.3rem,1.5rem)', marginBottom: '20px' }}>
                {selectedEvent?.extendedProps.isNote ? 'Edit Note' : 'Edit Scheduled Job'}
              </div>
              <form onSubmit={handleScheduleEditSubmit} style={{ padding: '0 10px' }}>
                {selectedEvent?.extendedProps.isNote ? (
                  <>
                    <div style={{ marginBottom: '18px' }}>
                      <label style={{ display: 'block', marginBottom: '6px', fontWeight: 500 }}>
                        Start date & time
                      </label>
                      <input
                        type="datetime-local"
                        value={
                          selectedEvent.start
                            ? new Date(selectedEvent.start).toISOString().slice(0, 16)
                            : ''
                        }
                        onChange={(e) => {
                          const newStart = new Date(e.target.value);
                          if (!isNaN(newStart.getTime())) {
                            selectedEvent.setStart(newStart);
                            setScheduleEditFormData(prev => ({ ...prev, start: newStart.toISOString() }));
                          }
                        }}
                        style={{ width: '100%', padding: '9px', border: '1px solid #ccc', borderRadius: '5px', fontSize: '1rem' }}
                      />
                    </div>
                    <div style={{ marginBottom: '18px' }}>
                      <label style={{ display: 'block', marginBottom: '6px', fontWeight: 500 }}>
                        Duration (hours)
                      </label>
                      <input
                        type="number"
                        value={
                          selectedEvent.start && selectedEvent.end
                            ? ((new Date(selectedEvent.end) - new Date(selectedEvent.start)) / (1000 * 60 * 60)).toFixed(2)
                            : '1.00'
                        }
                        onChange={(e) => {
                          const hours = parseFloat(e.target.value) || 1;
                          if (selectedEvent.start) {
                            const newEnd = new Date(selectedEvent.start);
                            newEnd.setTime(newEnd.getTime() + hours * 60 * 60 * 1000);
                            selectedEvent.setEnd(newEnd);
                            setScheduleEditFormData(prev => ({ ...prev, end: newEnd.toISOString() }));
                          }
                        }}
                        style={{ width: '100%', padding: '9px', border: '1px solid #ccc', borderRadius: '5px', fontSize: '1rem' }}
                      />
                    </div>
                    <div style={{ marginBottom: '20px' }}>
                      <label style={{ display: 'block', marginBottom: '6px', fontWeight: 500 }}>
                        Note text
                      </label>
                      <textarea
                        style={{ width: '100%', height: '140px', padding: '10px', border: '1px solid #ccc', borderRadius: '5px', resize: 'vertical', fontSize: '1rem' }}
                        value={scheduleEditFormData.content || ''}
                        onChange={e => setScheduleEditFormData(prev => ({ ...prev, content: e.target.value }))}
                        placeholder="Enter or edit your note here..."
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                      <div style={{ flex: 1 }}>Customer:</div>
                      <div style={{ flex: 2 }}>
                        <input
                          type="text"
                          style={{ width: '100%' }}
                          value={scheduleEditFormData.customer || ''}
                          onChange={e => setScheduleEditFormData(prev => ({ ...prev, customer: e.target.value }))}
                        />
                      </div>
                      <div style={{ flex: 1, textAlign: 'right', paddingRight: '10px' }}>Job:</div>
                      <div style={{ flex: 2 }}>
                        <input
                          type="text"
                          style={{ width: '100%' }}
                          value={scheduleEditFormData.job || ''}
                          onChange={e => setScheduleEditFormData(prev => ({ ...prev, job: e.target.value }))}
                        />
                      </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                      <div style={{ flex: 1 }}>Component:</div>
                      <div style={{ flex: 3 }}>
                        <input
                          type="text"
                          style={{ width: '100%' }}
                          value={scheduleEditFormData.component || ''}
                          onChange={e => setScheduleEditFormData(prev => ({ ...prev, component: e.target.value }))}
                        />
                      </div>
                      <div style={{ flex: 2 }}>&nbsp;</div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                      <div style={{ flex: 1 }}>Start Date & Time:</div>
                      <div style={{ flex: 4 }}>
                        <input
                          type="datetime-local"
                          style={{ width: '75%', padding: '5px 0px' }}
                          value={scheduleEditFormData.start || ''}
                          onChange={e => {
                            const newStartStr = e.target.value;
                            setScheduleEditFormData(prev => ({ ...prev, start: newStartStr }));
                            if (selectedEvent && newStartStr) {
                              const newStart = new Date(newStartStr);
                              if (!isNaN(newStart.getTime())) {
                                const durationMs = selectedEvent.end - selectedEvent.start;
                                const newEnd = new Date(newStart.getTime() + durationMs);
                                selectedEvent.setStart(newStart);
                                selectedEvent.setEnd(newEnd);
                              }
                            }
                          }}
                        />
                      </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                      <div style={{ flex: 1 }}>Press Machine:</div>
                      <div style={{ flex: 4 }}>
                        <select
                          style={{ width: '75%', padding: '5px 0px' }}
                          value={scheduleEditFormData.machine || currentMachine}
                          onChange={e => setScheduleEditFormData(prev => ({ ...prev, machine: e.target.value }))}
                        >
                          <option value="GL440">GL440</option>
                          <option value="GL540">GL540</option>
                        </select>
                      </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                      <div style={{ flex: 1 }}>FInk:</div>
                      <div style={{ flex: 2 }}>
                        <input
                          type="text"
                          style={{ width: '100%' }}
                          value={scheduleEditFormData.fink || ''}
                          onChange={e => setScheduleEditFormData(prev => ({ ...prev, fink: e.target.value }))}
                        />
                      </div>
                      <div style={{ flex: 1, textAlign: 'right', paddingRight: '10px' }}>BInk:</div>
                      <div style={{ flex: 2 }}>
                        <input
                          type="text"
                          style={{ width: '100%' }}
                          value={scheduleEditFormData.bink || ''}
                          onChange={e => setScheduleEditFormData(prev => ({ ...prev, bink: e.target.value }))}
                        />
                      </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                      <div style={{ flex: 1 }}>Length:</div>
                      <div style={{ flex: 2 }}>
                        <input
                          type="text"
                          style={{ width: '100%' }}
                          placeholder="Length"
                          value={scheduleEditFormData.sheetl || ''}
                          onChange={e => setScheduleEditFormData(prev => ({ ...prev, sheetl: e.target.value }))}
                        />
                      </div>
                      <div style={{ flex: 1, textAlign: 'right', paddingRight: '10px' }}>Width:</div>
                      <div style={{ flex: 2 }}>
                        <input
                          type="text"
                          style={{ width: '100%' }}
                          placeholder="Width"
                          value={scheduleEditFormData.sheetw || ''}
                          onChange={e => setScheduleEditFormData(prev => ({ ...prev, sheetw: e.target.value }))}
                        />
                      </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                      <div style={{ flex: 1 }}>Method:</div>
                      <div style={{ flex: 2 }}>
                        <select
                          style={{ width: '100%', padding: '5px 0px' }}
                          value={scheduleEditFormData.method || ''}
                          onChange={e => setScheduleEditFormData(prev => ({ ...prev, method: e.target.value }))}
                        >
                          <option value="">Select Method</option>
                          <option value="Sheetwise">Sheetwise</option>
                          <option value="Work & Turn">Work & Turn</option>
                          <option value="One-Sided">One-Sided</option>
                          <option value="Perfect">Perfect</option>
                          <option value="Work & Tumble">Work & Tumble</option>
                        </select>
                      </div>
                      <div style={{ flex: 1, textAlign: 'right', paddingRight: '10px' }}>Hours:</div>
                      <div style={{ flex: 2 }}>
                        <input
                          type="number"
                          style={{ width: '100%' }}
                          value={scheduleEditFormData.hours || '1'}
                          onChange={e => setScheduleEditFormData(prev => ({ ...prev, hours: e.target.value }))}
                        />
                      </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                      <div style={{ flex: 1 }}>Status:</div>
                      <div style={{ flex: 4 }}>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                          <div style={{ flex: 1 }}>Status:</div>
                          <div style={{ flex: 4 }}>
                            <select
                              style={{ width: '75%', padding: '5px 0px' }}
                              value={scheduleEditFormData.status || 'On Incoming'}
                              onChange={(e) => handleStatusChange(e.target.value)}
                            >
                              <option value="On Incoming">On Incoming</option>
                              <option value="On Press">On Press</option>
                              <option value="Off Press">Off Press</option>
                              <option value="Ready Press">Ready Press</option>
                              <option value="Incomplete Press">Incomplete Press</option>
                              <option value="Press AA Changes">Press AA Changes</option>
                            </select>
                            <div
                              style={{
                                display: 'inline-block',
                                width: '20px',
                                height: '20px',
                                backgroundColor: colorchange(scheduleEditFormData.status || 'On Incoming'),
                                border: '1px solid #888',
                                borderRadius: '4px',
                                marginLeft: '12px',
                                verticalAlign: 'middle',
                              }}
                            />
                            <span style={{ marginLeft: '8px', fontSize: '0.95em', color: '#444' }}>
                              {scheduleEditFormData.status || 'On Incoming'}
                            </span>
                          </div>
                          <div style={{ flex: 1 }}>&nbsp;</div>
                        </div>
                      </div>
                      <div style={{ flex: 1 }}>&nbsp;</div>
                    </div>
                  </>
                )}
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px', gap: '10px' }}>
                  <button
                    type="button"
                    onClick={() => setIsScheduleEditModalOpen(false)}
                    style={{ background: 'rgb(255,0,0,.7)', color: 'white', padding: '8px 20px', border: 'none', borderRadius: '4px' }}
                  >
                    Cancel
                 
                  </button>

                  <div style={{ display: 'flex', gap: '10px' }}>
                    <button
                      type="button"
                      style={{ background: 'rgb(255,0,0,.7)', color: 'white', padding: '8px 16px', border: 'none', borderRadius: '4px' }}
                      onClick={() => {
                        const type = selectedEvent.extendedProps.isNote ? "note" : "scheduled job";
                        if (window.confirm(`Are you sure you want to delete this ${type}?`)) {
                          handleScheduleRemove();
                        }
                      }}
                    >
                      Remove
                    </button>

                    {!selectedEvent?.extendedProps.isNote && (
                      <button
                        type="button"
                        className="duplicate"
                        onClick={handleScheduleDuplicate}
                        style={{ background: '#33c1dd', color: 'white', padding: '8px 20px', border: 'none', borderRadius: '4px' }}
                      >
                        Duplicate
                      </button>
                    )}

                    <button
                      type="submit"
                      style={{ background: '#4CAF50', color: 'white', padding: '8px 20px', border: 'none', borderRadius: '4px' }}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </>
        )}

        {/* Create Note Modal */}
        {isCreateNoteModalOpen && (
          <>
            <div className="modal-overlay" onClick={() => setIsCreateNoteModalOpen(false)}></div>
            <div className="modal" style={{ padding: '20px', maxWidth: '450px' }}>
              <h3 style={{ marginTop: 0 }}>Create New Note</h3>

              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px' }}>Date & Time:</label>
                <input
                  type="datetime-local"
                  value={createNoteForm.startDate}
                  onChange={e => setCreateNoteForm(prev => ({ ...prev, startDate: e.target.value }))}
                  style={{ width: '100%', padding: '8px' }}
                />
              </div>

              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px' }}>Duration (hours):</label>
                <input
                  type="number"
                  value={createNoteForm.durationHours}
                  onChange={e => setCreateNoteForm(prev => ({ ...prev, durationHours: parseFloat(e.target.value) || 0.5 }))}
                  style={{ width: '100%', padding: '8px' }}
                />
              </div>

              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '5px' }}>Note Text:</label>
                <textarea
                  value={createNoteForm.content}
                  onChange={e => setCreateNoteForm(prev => ({ ...prev, content: e.target.value }))}
                  placeholder="Enter your note here..."
                  style={{ width: '100%', height: '120px', padding: '8px', resize: 'vertical' }}
                />
              </div>

              <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                <button type="button" onClick={() => setIsCreateNoteModalOpen(false)}>
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={async () => {
                    const start = new Date(createNoteForm.startDate);
                    if (isNaN(start.getTime())) {
                      toast.error("Invalid date/time");
                      return;
                    }
                    const durationMs = (createNoteForm.durationHours || 0.5) * 60 * 60 * 1000;
                    const end = new Date(start.getTime() + durationMs);
                    const content = createNoteForm.content.trim() || "New Note";

                    try {
                      const res = await axios.post(`${api}/sched/add`, {
                        start: start.toISOString(),
                        end: end.toISOString(),
                        content,
                        isNote: true,
                        machine: currentMachine,
                      });

                      if (!res.data?._id) throw new Error("No ID returned");

                      const newDbId = res.data._id;

                      const newNoteEvent = {
                        id: `db-${newDbId}`,
                        title: content.slice(0, 40) || "Note",
                        start: start.toISOString(),
                        end: end.toISOString(),
                        extendedProps: {
                          isNote: true,
                          content,
                          dbId: newDbId,
                        },
                        backgroundColor: "#fffa65",
                        borderColor: "#fffa65",
                        textColor: "#000",
                      };

                      setMachineScheduled(prev => [...prev, newNoteEvent]);
                      toast.success("Note created");
                    } catch (err) {
                      console.error(err);
                      toast.error("Failed to create note");
                    }

                    setIsCreateNoteModalOpen(false);
                  }}
                  style={{ background: '#4caf50', color: 'white' }}
                >
                  Create Note
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default M110;



